<template>
    <div class="">
        <div class="modal fade" tabindex="-1" id="ModalProcessoArtefato">
            <div class="modal-dialog modal-dialog-centered modal-xxl">
                <div class="modal-content border-0">
                    <div class="modal-body">
                        <div class="py-4 px-4">
                            <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                <h3 class="title m-0">
                                    <i class="fas fa-file-alt me-2"></i>Artefato
                                </h3>
                            </div>
                            <hr />
                            <div v-if="estaBloqueado" class="alert alert-warning d-flex align-items-start gap-2 mb-3">
                                <i class="fas fa-circle-info"></i>
                                <div>
                                    <strong>Antes de avançar com este artefato</strong>
                                    <span v-if="dependencias?.length">
                                        , conclua primeiro o envio do(s) artefato(s) requerido(s): <strong>{{ dependenciasFmt }}</strong>.
                                        Assim que esses envios forem finalizados, as ações deste artefato ficarão disponíveis automaticamente.
                                    </span>
                                </div>
                            </div>
                            <div v-if="bloqueadoPorStatus && (isFinalizadoCd || ultimoTipoStatusHistorico === 'Finalizado')" class="alert alert-success d-flex align-items-start gap-2 mb-3">
                                <i class="fas fa-check-circle"></i>
                                <div>
                                    <template>
                                        <strong>Documento finalizado.</strong>
                                        <span>
                                            Este artefato foi finalizado; por se tratar de uma etapa concluída, não há alterações a realizar nesta fase.
                                        </span>
                                    </template>
                                </div>
                            </div>
                            <div v-if="emProcessamentoArtefato" class="alert alert-info d-flex align-items-start gap-2 mb-3">
                                <i class="fas fa-spinner fa-spin mt-1"></i>
                                <div>
                                    <strong>Processamento em andamento</strong>
                                    <div class="small">
                                        Aguarde a conclusão da geração por IA antes de executar outras ações neste artefato.
                                    </div>
                                </div>
                            </div>

                            <div v-if="bloqueadoPorStatus && !(isFinalizadoCd || ultimoTipoStatusHistorico === 'Finalizado')" class="alert alert-warning d-flex align-items-start gap-2 mb-3">
                                <i class="fas fa-circle-info"></i>
                                <div>
                                    <template>
                                        <strong>Este artefato já foi enviado.</strong>
                                        <span>
                                            No momento, encontra-se na etapa: <strong>{{ ultimoTipoStatusHistorico || '—' }}</strong>.
                                            As ações voltarão a ficar disponíveis se alterações e/ou edições forem requeridas.
                                        </span>
                                    </template>
                                </div>
                            </div>

                            <template v-if="processoModeloArtefato">
                                <div class="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-2">
                                    <div class="d-flex justify-content-between w-100">
                                        <p class="mb-0 fw-semibold fs-6">{{ processoModeloArtefato.nmModelo }}</p>
                                        <template v-if="manual != null">
                                            <ManualFerramenta :name="manual.name"
                                                              :btnClass="'btn-primary'"
                                                              :nameBtn="manual.nameBtn"
                                                              :urlPdf="manual.urlPdf" />
                                        </template>
                                    </div>

                                    <div class="card-responsavel">
                                        <template v-if="canEditarResponsavel">
                                            <div class="card-responsavel-body">
                                                <i class="fas fa-user-circle text-muted"></i>
                                                <select class="form-select form-select-sm"
                                                        v-model="responsavelLogin">
                                                    <option disabled value="">Selecione o responsável</option>
                                                    <option v-for="u in lstUsuariosResponsavel"
                                                            :key="u.dsLogin"
                                                            :value="u.dsLogin">
                                                        {{ u.nmUsuario }}
                                                    </option>
                                                </select>

                                                <i class="fas fa-calendar-alt text-muted" style="font-size: 0.9rem;"></i>
                                                <input type="date"
                                                       class="form-control form-control-sm prazo-input"
                                                       :class="{'prazo-disabled': !canEditarPrazo, 'is-invalid': canEditarPrazo && dataLimiteInvalida && dataLimiteDate}"
                                                       v-model="dataLimiteDate"
                                                       :min="hojeISO"
                                                       :disabled="!canEditarPrazo"
                                                       :title="!canEditarPrazo ? prazoDisabledReason : null"
                                                       lang="pt-BR"
                                                       inputmode="numeric"
                                                       @input="limitarAno" />
                                                <i v-if="isPrazoBloqueado"
                                                   class="fas fa-lock text-muted"
                                                   style="font-size: 0.8rem;"
                                                   :title="prazoDisabledReason"></i>

                                                <div class="card-responsavel-actions" v-if="!modoVisualizacao">
                                                    <button class="btn btn-sm btn-primary"
                                                            type="button"
                                                            @click="salvarResponsavel"
                                                            title="Salvar alterações">
                                                        <i class="fas fa-save"></i>
                                                    </button>
                                                    <button v-if="responsavelLogin"
                                                            class="btn btn-sm btn-outline-danger"
                                                            type="button"
                                                            title="Remover responsável"
                                                            @click="limparResponsavel">
                                                        <i class="fas fa-trash"></i>
                                                    </button>
                                                    <small v-if="saveState==='saving'" class="text-muted">Salvando…</small>
                                                    <small v-else-if="saveState==='saved'" class="text-success">Salvo</small>
                                                    <small v-else-if="saveState==='error'" class="text-danger">Erro ao salvar</small>
                                                </div>
                                            </div>
                                        </template>
                                        <div v-else class="card-responsavel-body-readonly">
                                            <i class="fas fa-user-circle text-muted"></i>
                                            <span class="responsavel-nome">
                                                {{ (lstUsuariosResponsavel.find(u => u.dsLogin === responsavelLogin)?.nmUsuario) || 'Não atribuído' }}
                                            </span>
                                            <span class="text-muted">•</span>
                                            <span class="text-muted">Prazo: {{ prazoBR }}</span>
                                            <i class="fas fa-lock text-muted" title="Somente o proprietário pode alterar."></i>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <!-- Card de Ações Principais -->
                            <div class="card-acoes-principais" v-if="processoArtefato || canDownloadAssinado || showBtnVerDocumento || showBtnRetificacao">
                                <div class="card-acoes-body">
                                    <button v-if="processoArtefato"
                                            class="btn btn-acoes btn-download"
                                            @click="downloadAtual(processoArtefato.idProcessoArtefato, processoArtefato.urlArquivo)"
                                            title="Download do arquivo atual">
                                        <i class="fas fa-download me-2"></i>
                                        <span>Download Documento Original</span>
                                    </button>
                                    <button v-if="podeAbrirInteracaoIa"
                                            class="btn btn-acoes btn-fluxo"
                                            @click="abrirInteracaoIa"
                                            :title="tituloInteracaoIa">
                                        <i class="fas fa-comments me-2"></i>
                                        <span>Edição assistida (IA)</span>
                                    </button>
                                    <button v-if="canDownloadAssinado"
                                            class="btn btn-acoes btn-download"
                                            @click="downloadAssinado"
                                            title="Download do documento assinado">
                                        <i class="fas fa-file-signature me-2"></i>
                                        <span>Download Assinado</span>
                                    </button>
                                    <button v-if="showBtnVerDocumento"
                                            class="btn btn-acoes btn-fluxo"
                                            @click="verDocumentoRevisado"
                                            :title="tooltipVerDocumento">
                                        <i class="fas fa-file-alt me-2"></i>
                                        <span>Ver Documento</span>
                                    </button>
                                    <button v-if="showBtnRetificacao"
                                            class="btn btn-acoes btn-warning"
                                            @click="retificarDocumento"
                                            :title="'Retificar documento finalizado.'">
                                        <i class="fas fa-edit me-2"></i>
                                        <span>Retificar Documento</span>
                                    </button>
                                </div>

                                <!-- Mensagem sutil guiando o usuário -->
                                <div v-if="showBtnVerDocumento"
                                     class="mt-2 text-muted small d-flex align-items-start gap-2">
                                    <i class="fas fa-info-circle mt-1"></i>
                                    <span>{{ textoAjudaVerDocumento }}</span>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-xl-4">

                                    <ul class="d-flex flex-column gap-2 h-100">
                                        <li v-for="(item,index) in lstTiposEnvios" :key="index">
                                            <template v-if="item.cdTipoEnvio == 'GI'">
                                                <!--<button :class="(flPermissao?'btn btn-light w-100':'btn btn-outline-light w-100')"
                                                        @click="(flPermissao?abreFormulario(item):null)"
                                                        :disabled="acoesDesabilitadas"
                                                        :title="motivoBloqueioAcao || null">
                                                    Preencher Informações
                                                </button>-->
                                                <button class="btn btn-light w-100"
                                                        @click="abreFormulario(item)"
                                                        :title="motivoBloqueioAcao || null">
                                                    Preencher Informações
                                                </button>
                                                <button :class="(flPermissao?'btn btn-light w-100 mt-2':'btn btn-outline-light w-100 mt-2')"
                                                        @click="enviaFormulario"
                                                        :disabled="acoesDesabilitadas"
                                                        :title="motivoBloqueioAcao || null">
                                                    Gerar Artefato com IA
                                                </button>
                                            </template>
                                            <template v-else>
                                                <button :class="(flPermissao?'btn btn-light w-100':'btn btn-outline-light w-100')"
                                                        @click="(flPermissao?acaoTipoEnvio(item):null)"
                                                        :disabled="acoesDesabilitadas"
                                                        :title="motivoBloqueioAcao || null">
                                                    {{item.nmTipoEnvio}}
                                                </button>
                                            </template>

                                        </li>
                                        <li v-if="processoModeloArtefato && processoModeloArtefato.nmModelo === 'Mapa de Risco'">
                                            <button :class="(flPermissao?'btn btn-light w-100':'btn btn-outline-light w-100')"
                                                    @click="(flPermissao?abrirModalMatrizRiscos():null)"
                                                    :disabled="acoesDesabilitadas"
                                                    :title="motivoBloqueioAcao || null">
                                                Mapa de Risco
                                            </button>
                                        </li>
                                    </ul>

                                </div>
                                <div class="col-12 col-xl-8 mt-5 mt-xl-0">
                                    <div class="row g-4">
                                        <div class="col-12 col-lg-6">
                                            <div class="section-card">
                                                <div class="d-flex justify-content-between align-items-center mb-2">
                                                    <h3 class="mb-0">
                                                        <i class="fas fa-history me-2"></i>Histórico
                                                    </h3>
                                                    <button v-if="showBtnCancelarProcessamento"
                                                            type="button"
                                                            class="btn btn-sm btn-outline-warning"
                                                            :disabled="cancelarProcessamentoLoading"
                                                            title="Cancela o processamento travado e libera uma nova geração"
                                                            @click="confirmarCancelarProcessamento()">
                                                        <i class="fas fa-ban me-1"></i>
                                                        {{ cancelarProcessamentoLoading ? 'Cancelando...' : 'Cancelar processamento' }}
                                                    </button>
                                                </div>

                                                <template v-if="lstProcessoArtefatoHistorico">
                                                    <ul class="list-group mt-3">
                                                        <template v-if="processoArtefatoAssistente">
                                                            <li class="list-group-historico" v-if="processoArtefatoAssistente.fileId == null">
                                                                Falha ao processar Artefato
                                                                <button class="btn btn-warning me-2" @click="reprocessar(processoArtefato.idProcessoArtefato)">
                                                                    <i class="fas fa-sync-alt"></i> Reprocessar
                                                                </button>
                                                            </li>
                                                        </template>

                                                        <li class="list-group-historico"
                                                            v-for="(item,index) in lstProcessoArtefatoHistorico" :key="index"
                                                            data-bs-toggle="popover" data-bs-placement="right" title="Detalhes"
                                                            :data-bs-content="getDataBsHistorico(item)">
                                                            <div class="tyn-media-group">
                                                                {{ item.dsMovimento }} - {{ formatDate(item.dtInclusao) }}
                                                                <div class="tyn-media-option opacity-100">
                                                                    <ul class="tyn-media-option-list">
                                                                        <li>
                                                                            <button class="btn btn-icon btn-md btn-pill btn-light"
                                                                                    v-if="item.idReferencia == 0 && item.nmTipoEnvio == 'Solicitar envio'"
                                                                                    @click="abrirLink(item.urlArquivo)">
                                                                                <i class="fas fa-share"></i>
                                                                            </button>
                                                                            <button class="btn btn-icon btn-md btn-pill btn-light"
                                                                                    @click="downloaHistorico(item.idReferencia, item.urlArquivo)"
                                                                                    v-if="item.idReferencia > 0">
                                                                                <i class="fas fa-download"></i>
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </li>

                                                        <li v-if="lstProcessoArtefatoHistorico && lstProcessoArtefatoHistorico.length == 0">
                                                            Nenhum registro encontrado
                                                        </li>
                                                    </ul>
                                                </template>
                                            </div>
                                        </div>

                                        <div class="col-12 col-lg-6">
                                            <div class="section-card">
                                                <div class="d-flex justify-content-between align-items-center mb-2">
                                                    <h3 class="mb-0">
                                                        <i class="fas fa-tasks me-2"></i>Status
                                                    </h3>
                                                    <button v-if="showBtnVoltarEtapa"
                                                            type="button"
                                                            class="btn btn-sm btn-outline-warning"
                                                            :disabled="voltarEtapaLoading"
                                                            title="Volta ao status anterior para escolher novos revisores ou aprovadores"
                                                            @click="confirmarVoltarEtapa()">
                                                        <i class="fas fa-undo me-1"></i>
                                                        {{ voltarEtapaLoading ? 'Revertendo...' : 'Voltar etapa' }}
                                                    </button>
                                                </div>

                                                <template v-if="lstProcessoArtefatoStatusHistorico">
                                                    <ul class="list-group mt-3">
                                                        <li class="list-group-historico"
                                                            v-for="(st, idx) in lstProcessoArtefatoStatusHistorico" :key="'st-'+idx"
                                                            data-bs-toggle="popover" data-bs-placement="right" title="Detalhes"
                                                            :data-bs-content="getDataBsHistoricoStatus(st)">
                                                            <div class="tyn-media-group">
                                                                {{ st.nmTipoStatusHistorico }} - {{(st.nmUsuario?.length > 50?st.nmUsuario.slice(0,50)+'...' :st.nmUsuario)}} - {{ formatDate(st.dtInclusao) }}
                                                            </div>
                                                        </li>

                                                        <li v-if="lstProcessoArtefatoStatusHistorico && lstProcessoArtefatoStatusHistorico.length === 0">
                                                            Nenhum status encontrado
                                                        </li>
                                                    </ul>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div><!-- .modal-body -->
                    <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3" data-bs-dismiss="modal" @click="$emit('update:showModal', false)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg><!-- x-lg -->
                    </button><!-- modal-close -->
                </div><!-- .modal-content -->
            </div><!-- .modal-dialog -->
        </div><!-- .modal -->
        <div class="modal fade" tabindex="-1" id="ModalUpload">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content border-0">
                    <div class="modal-body">
                        <div class="py-4 px-4">
                            <h3 class="title">
                                <i class="fas fa-cloud-upload-alt me-2"></i>Upload
                            </h3>
                            <hr />
                            <p class="text-muted"><i class="fas fa-info-circle me-2"></i>Envie seu Artefato do Processo</p>

                            <AvisoUploadDocumentos />

                            <div class="upload-center">
                                <InputUploadS3 :reset="resetUpload"
                                               :labelText="'Selecionar Arquivo'"
                                               @onSave="setUploadFile"
                                               @onDelete="deleteUploadFile"
                                               :destino="'ProcessoArtefato'"
                                               :maxFileSize="800"
                                               :multiple="false"
                                               :id="'input_file_upload_retificacao'"
                                               :whoFiles="'.pdf,.doc,.docx'"></InputUploadS3>
                            </div>
                            <p class="text-center mb-1">(Formatos aceitos: <strong>.pdf,.doc ou .docx</strong> - Tamanho máximo: 800MB)</p>

                            <button class="btn btn-primary w-100 mt-2" type="button" @click="enviarUpload">Enviar</button>
                        </div>
                    </div><!-- .modal-body -->
                    <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3" data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg><!-- x-lg -->
                    </button><!-- modal-close -->
                </div><!-- .modal-content -->
            </div><!-- .modal-dialog -->
        </div><!-- .modal -->
        <!-- FORMULARIO -->
        <div class="modal fade" tabindex="-1" id="ModalFormulario" v-if="flTemFormulario">
            <div class="modal-dialog modal-dialog-centered modal-xxl">
                <div class="modal-content border-0">
                    <div class="modal-body">
                        <div class="py-4 px-4" v-if="flTemFormulario">
                            <div class="d-flex justify-content-between align-items-center">
                                <h3 class="title">
                                    <i class="fas fa-clipboard-list me-2"></i>Formulário
                                </h3>
                            </div>

                            <hr />
                            <template v-if="processoModeloArtefato">
                                <h3>
                                    <i class="fas fa-file-contract me-2"></i>{{processoModeloArtefato.nmModelo}}
                                </h3>
                            </template>
                            <p class="text-muted">
                                <i class="fas fa-lightbulb me-2"></i>Preencha os dados do formulário para melhorar minha precisão ao elaborar seu documento.
                            </p>

                            <component :is="componenteFormulario" v-if="componenteFormulario && processoModeloArtefatoConfiguracao"
                                       :idModeloArtefato="processoModeloArtefatoConfiguracao.idModeloArtefato"
                                       :idProcesso="parseInt(idProcesso)"
                                       :idProcessoModeloArtefato="parseInt(idProcessoModeloArtefato)"
                                       :flPermissao="flPermissao"
                                       ></component>

                        </div>
                    </div>
                    <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3" data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
        <ModalMatrizRiscos ref="modalMatrizRiscos" :idProcesso="idProcesso" :idProcessoModeloArtefato="idProcessoModeloArtefato" :dsNome="dsNome" />
        <div class="modal fade" tabindex="-1" id="ModalRetificarDocumento">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content border-0">
                    <div class="modal-body">
                        <div class="py-4 px-4">
                            <h3 class="title">
                                <i class="fas fa-edit me-2"></i>Retificar Documento
                            </h3>
                            <hr />
                            <div class="form-group mb-3">
                                <label class="form-label" id="lavel_dsMotivoRetificacao">Motivo da Retificação</label>
                                <textarea class="form-control"
                                          :class="{ 'border-danger': validacaoMotivoRetificacao }"
                                          id="dsMotivoRetificacao" maxlength="500" v-model="dsMotivoRetificacao"></textarea>
                            </div>

                            <p class="text-muted"><i class="fas fa-info-circle me-2"></i>Envie seu Artefato Retificado</p>

                            <div class="upload-center">
                                <InputUploadS3 :reset="resetUpload"
                                               :labelText="'Selecionar Arquivo'"
                                               @onSave="setUploadFile"
                                               @onDelete="deleteUploadFile"
                                               :destino="'ProcessoArtefato'"
                                               :maxFileSize="800"
                                               :multiple="false"
                                               :id="'input_file_upload'"
                                               :whoFiles="'.pdf,.doc,.docx'"></InputUploadS3>
                            </div>
                            <p class="text-center mb-1">(Formatos aceitos: <strong>.pdf,.doc ou .docx</strong> - Tamanho máximo: 800MB)</p>

                            <button class="btn btn-primary w-100 mt-2" type="button" @click="enviarRetificacao">Enviar</button>
                        </div>
                    </div><!-- .modal-body -->
                    <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3" data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg><!-- x-lg -->
                    </button><!-- modal-close -->
                </div><!-- .modal-content -->
            </div><!-- .modal-dialog -->
        </div><!-- .modal -->
        <div class="modal fade" tabindex="-1" id="ModalEnvioArquivoProcessamento">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content border-0">
                    <div class="modal-body">
                        <div class="py-4 px-4">
                            <h3 class="title">
                                <i class="fas fa-cloud-upload-alt me-2"></i>Envio de {{ permiteMultiplosArquivosGA ? 'Arquivos' : 'Arquivo' }} para Processamento
                            </h3>
                            <hr />
                            <p class="text-muted">
                                <i class="fas fa-info-circle me-2"></i>
                                <template v-if="permiteMultiplosArquivosGA">Envie até {{ maxArquivosGA }} arquivos para Processamento</template>
                                <template v-else>Envie seu arquivo para Processamento</template>
                            </p>

                            <AvisoUploadDocumentos />

                            <div class="upload-center">
                                <InputUploadS3 :reset="resetUpload"
                                               :labelText="permiteMultiplosArquivosGA ? 'Selecionar Arquivos' : 'Selecionar Arquivo'"
                                               @onSave="setUploadFileProcessamento"
                                               @onDelete="deleteUploadFileProcessamento"
                                               :destino="'ProcessoArtefato'"
                                               :maxFileSize="800"
                                               :multiple="permiteMultiplosArquivosGA"
                                               :maxFiles="maxArquivosGA"
                                               :id="'input_file_upload_processamento'"
                                               :whoFiles="'.pdf,.doc,.docx'"></InputUploadS3>
                            </div>
                            <p class="text-center mb-1">(Formatos aceitos: <strong>.pdf,.doc ou .docx</strong> - Tamanho máximo: 800MB<template v-if="permiteMultiplosArquivosGA"> por arquivo - até {{ maxArquivosGA }} arquivos</template>)</p>

                            <button class="btn btn-primary w-100 mt-2" type="button" @click="enviarArquivoProcessamento">Enviar</button>
                        </div>
                    </div><!-- .modal-body -->
                    <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3" data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg><!-- x-lg -->
                    </button><!-- modal-close -->
                </div><!-- .modal-content -->
            </div><!-- .modal-dialog -->
        </div><!-- .modal -->
    </div>
    
</template>

<script>

    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'
    import InputUploadS3 from '@/components/Input_Upload_s3Centralizado'
    import AvisoUploadDocumentos from '@/components/AvisoUploadDocumentos'
    import Swal from 'sweetalert2'
    import ModalMatrizRiscos from '@/components/ModalMatrizRiscos'
    import formDFD from '@/components/ModeloArtefatoFormulario/formDFD'
    import formETP from '@/components/ModeloArtefatoFormulario/formETP'
    import formDFD13303 from '@/components/ModeloArtefatoFormulario/formDFD13303'
    import formETP13303 from '@/components/ModeloArtefatoFormulario/formETP13303'
    import ManualFerramenta from '@/components/Ferramentas/ManualFerramenta'
    
    export default {
        name: 'ModalProcessoArtefato',
        components: {
            InputUploadS3,
            AvisoUploadDocumentos,
            ModalMatrizRiscos,
            formDFD,
            formETP,
            formDFD13303,
            formETP13303,
            ManualFerramenta
        },
        props: {
            showModal: Boolean,
            idProcessoModeloArtefato: String,
            idProcesso: String,
            dsNome: String,
            nrOrdem: Number,
            flPermissao: Boolean,
            flProprietario: Boolean,
            idLegislacao: Number,
            cdLegislacao: Number,
            flPrazo: { type: Boolean, default: false },
            bloqueado: { type: Boolean, default: false },
            dependencias: { type: Array, default: () => [] },
            etapaFluxo: { type: String, default: null },
            temAlgumaEtapa: { type: Boolean, default: false },
            dsLoginProprietario: { type: String, default: null },
            flTemWorkflow: { type: Boolean, default: false },
            modoVisualizacao: Boolean,
        },
        computed: {
            hubConection() {
                return this.$store.state.hubConection
            },
            semEtapaFluxo() {
                return !this.flTemWorkflow;
            },

            temDocumentoDisponivel() {
                // documento só existe após a IA finalizar o processamento (registro do artefato criado)
                return !!(this.processoArtefato && this.processoArtefato.idProcessoArtefato);
            },
            showBtnVerDocumento() {
                if (this.semEtapaFluxo) return false;

                // evita exibir "Ver Documento" enquanto a IA ainda processa (documento inexistente)
                if (!this.temDocumentoDisponivel) return false;

                const podeFluxo = this.jaTemArtefatoEnviado
                    && !this.acoesDesabilitadas;

                const podeRevisadoOuAprovado = this.showBtnDocumentoRevisado;

                return podeFluxo || podeRevisadoOuAprovado;
            },
            showBtnRetificacao() {
                return this.ultimoCdStatusHistorico === '10';
            },
            podeAbrirInteracaoIa() {
                const nm = (this.processoModeloArtefato?.nmModelo || '').toLowerCase();
                const modeloLiberado = nm.includes('termo de refer')
                    || nm === 'edital'
                    || nm === 'minuta do edital';
                return !!(this.processoArtefato?.idProcessoArtefato && this.processoArtefato?.urlArquivo && modeloLiberado);
            },
            tituloInteracaoIa() {
                const nm = this.processoModeloArtefato?.nmModelo;
                return nm
                    ? `Editar ${nm} com chat IA`
                    : 'Editar o documento com chat IA';
            },

            btnFluxoTexto() {
                if (this.semEtapaFluxo) return ''; 
                const etapa = (this.etapaFluxo || '').toLowerCase();
                if (etapa === 'revisao') return 'Enviar para Revisão';
                if (etapa === 'aprovacao') return 'Enviar para Aprovação';
                if (etapa === 'assinatura') return 'Enviar para Assinatura';
                return 'Seguir no Fluxo';
            },
            jaTemArtefatoEnviado() {
                if (this.processoArtefato?.idProcessoArtefato) return true;
                const hist = this.lstProcessoArtefatoHistorico;
                if (Array.isArray(hist) && hist.length) {
                    return hist.some(h =>
                        (h?.idReferencia ?? 0) > 0 ||
                        (h?.nmTipoEnvio && h.nmTipoEnvio.toLowerCase() !== 'solicitar envio')
                    );
                }

                return false;
            },
            hasStatusAssinado() {
                const arr = this.lstProcessoArtefatoStatusHistorico;
                if (!Array.isArray(arr) || !arr.length) return false;

                return arr.some(st => {
                    const cd = st.cdTipoStatusHistorico ?? st.idTipoStatusHistorico;
                    return String(cd) === '8';
                });
            },

            canDownloadAssinado() {
                if (!this.hasStatusAssinado) return false;

                const p = this.ProcessoAssinatura || {};
                return !!(p.idProcessoCertificadora && p.idDocumentoCertificadora);
            },
            permiteMultiplosArquivosGA() {
                return this.processoModeloArtefato?.cdModelo === 1;
            },
            maxArquivosGA() {
                return this.permiteMultiplosArquivosGA ? 15 : 1;
            },
            componenteFormulario() {
                const modelo = this.processoModeloArtefato.cdModelo
                const legis = Number(this.cdLegislacao)

                if (!modelo) return null
                if (legis === 3) {
                    switch (modelo) {
                        case 1: return 'formDFD13303'
                        case 2: return 'formETP13303'
                        default: return null
                    }
                } else { // legis === 1 
                    switch (modelo) {
                        case 1: return 'formDFD'
                        case 2: return 'formETP'
                        default: return null
                    }
                }
            },
            ultimoTipoStatusHistorico() {
                const arr = this.lstProcessoArtefatoStatusHistorico;
                if (Array.isArray(arr) && arr.length) {
                    return arr[0]?.nmTipoStatusHistorico || null;
                }
                return null;
            },
            ultimoCdStatusHistorico() {
                const arr = this.lstProcessoArtefatoStatusHistorico;
                if (Array.isArray(arr) && arr.length) {
                    const raw = arr[0]?.cdTipoStatusHistorico ?? arr[0]?.idTipoStatusHistorico ?? null;
                    return raw === null || raw === undefined ? null : String(raw);
                }
                return null;
            },
            bloqueadoPorStatus() {
                const cd = this.ultimoCdStatusHistorico;
                const t = this.ultimoTipoStatusHistorico;
                const isFinalizado = this.isFinalizadoCd || t === 'Finalizado';
                if (this.semEtapaFluxo) {
                    return isFinalizado;
                }
                if (cd) {
                    return !(['1', '2', '9', '11'].includes(cd));
                }
                if (!t) return false;
                return !(t === 'Aguardando Envio' || t === 'Enviado' || t === 'Retificado');
            },

            isFinalizadoCd() {
                return this.ultimoCdStatusHistorico === '10';
            },
            hojeISO() {
                const d = new Date();
                const pad = n => (n < 10 ? "0" + n : n);
                return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
            },

            dataLimiteInvalida() {
                if (!this.dataLimiteDate) return true;
                const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
                const escolhida = new Date(this.dataLimiteDate + 'T00:00:00');
                return escolhida < hoje;
            },

            dataLimiteValida() {
                return !this.dataLimiteInvalida;
            },

            dataLimitePreviewBR() {
                if (!this.dataLimiteDate) return "";
                return `${moment(this.dataLimiteDate, 'YYYY-MM-DD').format('DD/MM/YYYY')} 23:59`;
            },

            prazoBR() {
                return this.dataLimiteDate
                    ? moment(this.dataLimiteDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
                    : '—'
            },

            temResponsavel() {
                return Number(this.idProcessoArtefatoResponsavel) > 0;
            },
            ultimoStatusObj() {
                const arr = this.lstProcessoArtefatoStatusHistorico;
                return (Array.isArray(arr) && arr.length) ? arr[0] : null;
            },
            showBtnDocumentoRevisado() {
                return this.ultimoCdStatusHistorico === '4'
                    || this.ultimoCdStatusHistorico === '6'
                    || this.ultimoCdStatusHistorico === '7'
                    || this.ultimoCdStatusHistorico === '9'
            },

            tooltipVerDocumento() {
                if (this.isFinalizadoCd || this.ultimoTipoStatusHistorico === 'Finalizado') {
                    return 'Abrir o documento finalizado para consulta.';
                }
                return 'Abrir o documento para revisar, aprovar ou assinar conforme o fluxo.';
            },

            textoAjudaVerDocumento() {
                if (this.isFinalizadoCd || this.ultimoTipoStatusHistorico === 'Finalizado') {
                    return 'Este documento já foi concluído. Você ainda pode consultá-lo clicando em "Ver Documento".';
                }
                return 'Clique em "Ver Documento" para acessar o documento e dar continuidade ao fluxo configurado no fluxo de trabalho.';
            },
            labelBtnDocumentoRevisado() {
                if (this.ultimoCdStatusHistorico === '6') return 'Ver Documento Aprovado'
                if (this.ultimoCdStatusHistorico === '7') return 'Ver Documento em Assinatura'
                return 'Ver Documento Revisado'
            },
            idProcessoArtefatoValue() {
                return this.processoArtefato && this.processoArtefato.idProcessoArtefato
                    ? this.processoArtefato.idProcessoArtefato
                    : null;
            },
            isPrazoBloqueado() {
                return !!this.flPrazo;
            },
            estaBloqueado() {
                return !!this.bloqueado;
            },
            dependenciasFmt() {
                return (this.dependencias || []).filter(Boolean).join(', ');
            },
            emProcessamentoArtefato() {
                return !!(this.statusProcessamento && this.statusProcessamento.emAndamento);
            },
            isAdmin() {
                return this.$store.state.isAdmin === 'Sim'
                    || (this.loginUsuarioAtual || '').toLowerCase() === 'admin';
            },
            podeCancelarProcessamentoPermissao() {
                return this.podeVoltarEtapa || this.isAdmin;
            },
            showBtnCancelarProcessamento() {
                if (this.modoVisualizacao || !this.podeCancelarProcessamentoPermissao) return false;
                return !!(this.statusProcessamento && this.statusProcessamento.flPodeCancelar);
            },
            acoesDesabilitadas() {
                return !this.flPermissao
                    || this.estaBloqueado
                    || this.bloqueadoPorStatus
                    || this.modoVisualizacao
                    || this.emProcessamentoArtefato;
            },
            motivoBloqueio() {
                if (this.emProcessamentoArtefato) {
                    return 'Existe um processamento de geração em andamento. Aguarde a conclusão ou cancele se estiver travado há mais de 2 horas.';
                }
                if (this.estaBloqueado) {
                    return this.dependencias?.length
                        ? `Antes de avançar, conclua o envio de: ${this.dependenciasFmt}.`
                        : 'Este artefato segue etapas do fluxo e aguarda liberações anteriores.';
                }
                if (this.bloqueadoPorStatus) {
                    const t = this.ultimoTipoStatusHistorico || '—';
                    if (this.isFinalizadoCd || t === 'Finalizado') {
                        return 'Este artefato foi finalizado; por se tratar de uma etapa concluída, não há alterações a realizar nesta fase.';
                    }
                    return `Este artefato já foi enviado e encontra-se em etapa de análise (${t}). As ações voltam a ficar disponíveis quando o status for Aguardando Envio ou Aguardando Reenvio.`;
                }
                return '';
            },
            motivoBloqueioAcao() {
                if (this.estaBloqueado || this.bloqueadoPorStatus || this.emProcessamentoArtefato) {
                    return this.motivoBloqueio;
                }
                return '';
            },
            canEditarResponsavel() {
                return !!this.flProprietario;
            },
            canEditarPrazo() {
                return !!this.flProprietario && !this.isPrazoBloqueado;
            },
            prazoDisabledReason() {
                if (!this.flProprietario) return 'Somente o proprietário pode alterar.';
                if (this.isPrazoBloqueado) return 'Prazo definido pelo fluxo de trabalho.';
                return '';
            },
            usuarioLogado() {
                return this.$store.state.user;
            },
            loginUsuarioAtual() {
                return (this.usuarioLogado?.usuario?.dsLogin || '').trim();
            },
            isResponsavelArtefato() {
                const login = this.loginUsuarioAtual;
                const resp = (this.responsavelLogin || '').trim();
                return !!login && !!resp && login.toLowerCase() === resp.toLowerCase();
            },
            podeVoltarEtapa() {
                return !!this.flProprietario || this.isResponsavelArtefato;
            },
            showBtnVoltarEtapa() {
                if (this.modoVisualizacao || !this.flPermissao || !this.podeVoltarEtapa) return false;
                const cd = this.ultimoCdStatusHistorico;
                return cd === '3' || cd === '5' || cd === '7';
            },
        },
        data: function () {
            return {
                processoArtefato: null,
                processoModeloArtefato: null,
                processoModeloArtefatoConfiguracao: null,
                lstProcessoArtefatoHistorico: null,
                lstProcessoArtefatoStatusHistorico: null,
                lstTiposEnvios: null,
                mostrarSelecaoModeloEdital: false,
                modeloEditalSelecionado: null,
                resetUpload: false,
                camposInvalidos: {},
                lstFormulario: [],
                flTemFormulario: false,
                indexFormulario: 0,
                indexUltimaEtapaAvancada: 0,
                lstArtefatoFormulario: null,
                lstUsuariosResponsavel: [],
                responsavelLogin: "",
                responsavelObrigatorio: false,
                voltarEtapaLoading: false,
                cancelarProcessamentoLoading: false,
                statusProcessamento: null,
                intervaloStatusProcessamento: null,
                dataLimiteDate: "", 
                idProcessoArtefatoResponsavel: null,
                respostas: {},
                editais: [],
                lstTermoContrato: [],
                lstParecerParametrizado: [],
                termoRefenrencia: [],
                saveState: 'idle',
                saveDebounce: null,
                isReadyForAutosave: false,
                ProcessoAssinatura: {},
                lstArquivosProcessamento: [],
                dsMotivoRetificacao: null,
                validacaoMotivoRetificacao: false,
                lstValidacaoForm: [
                    {
                        cdModelo: 1,
                        cdLegislacao: 1,
                        lstCampos: [
                            // 'cdEtapa' para encontrar no banco
                            { cdEtapa: 1, cdFormulario: 0, flObrigatorio: true,},
                            { cdEtapa: 1, cdFormulario: 1, flObrigatorio: true,},
                            { cdEtapa: 2, cdFormulario: 0, flObrigatorio: true,},
                            { cdEtapa: 3, cdFormulario: 0, flObrigatorio: true,},
                            { cdEtapa: 3, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 4, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 4, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 5, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 5, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 6, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 6, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 7, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 7, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 8, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 8, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 45, cdFormulario: 0, flObrigatorio: false, },
                            { cdEtapa: 45, cdFormulario: 1, flObrigatorio: false, },
                        ]
                    },
                    {
                        cdModelo: 2,
                        cdLegislacao: 1,
                        lstCampos: [
                            { cdEtapa: 9, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 9, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 9, cdFormulario: 2, flObrigatorio: true, },
                            { cdEtapa: 9, cdFormulario: 3, flObrigatorio: true, },

                            { cdEtapa: 10, cdFormulario: 0, flObrigatorio: true, },

                            { cdEtapa: 11, cdFormulario: 0, flObrigatorio: false, },
                            { cdEtapa: 11, cdFormulario: 1, flObrigatorio: false, },
                            { cdEtapa: 11, cdFormulario: 4, flObrigatorio: false, },
                            { cdEtapa: 11, cdFormulario: 5, flObrigatorio: false, },
                            { cdEtapa: 11, cdFormulario: 6, flObrigatorio: false, },
                            { cdEtapa: 11, cdFormulario: 7, flObrigatorio: false, },
                            { cdEtapa: 11, cdFormulario: 8, flObrigatorio: false, },
                            { cdEtapa: 11, cdFormulario: 10, flObrigatorio: false, },
                            { cdEtapa: 11, cdFormulario: 13, flObrigatorio: false, },

                            { cdEtapa: 12, cdFormulario: 0, flObrigatorio: false, },
                            { cdEtapa: 12, cdFormulario: 1, flObrigatorio: false, },
                            { cdEtapa: 12, cdFormulario: 2, flObrigatorio: false, },
                            { cdEtapa: 12, cdFormulario: 3, flObrigatorio: false, },
                            { cdEtapa: 12, cdFormulario: 4, flObrigatorio: false, },
                            { cdEtapa: 12, cdFormulario: 5, flObrigatorio: false, },
                            { cdEtapa: 12, cdFormulario: 6, flObrigatorio: false, },
                            { cdEtapa: 12, cdFormulario: 7, flObrigatorio: false, },
                            { cdEtapa: 12, cdFormulario: 8, flObrigatorio: false, },
                            { cdEtapa: 12, cdFormulario: 9, flObrigatorio: false, },
                            { cdEtapa: 12, cdFormulario: 11, flObrigatorio: false, },
                            { cdEtapa: 12, cdFormulario: 13, flObrigatorio: false, },
                            { cdEtapa: 12, cdFormulario: 15, flObrigatorio: false, },
                            { cdEtapa: 12, cdFormulario: 17, flObrigatorio: false, },
                            { cdEtapa: 12, cdFormulario: 19, flObrigatorio: false, },
                            { cdEtapa: 12, cdFormulario: 20, flObrigatorio: false, },
                            { cdEtapa: 12, cdFormulario: 21, flObrigatorio: false, },

                            { cdEtapa: 13, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 13, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 13, cdFormulario: 2, flObrigatorio: true, },
                            { cdEtapa: 13, cdFormulario: 3, flObrigatorio: true, },
                            { cdEtapa: 13, cdFormulario: 4, flObrigatorio: true, },
                            { cdEtapa: 13, cdFormulario: 6, flObrigatorio: true, },

                            { cdEtapa: 14, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 14, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 14, cdFormulario: 2, flObrigatorio: true, },
                            { cdEtapa: 14, cdFormulario: 3, flObrigatorio: true, },

                            { cdEtapa: 15, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 15, cdFormulario: 13, flObrigatorio: true, },
                            { cdEtapa: 15, cdFormulario: 14, flObrigatorio: true, },

                            { cdEtapa: 16, cdFormulario: 0, flObrigatorio: false, },
                            { cdEtapa: 16, cdFormulario: 2, flObrigatorio: false, },
                            { cdEtapa: 16, cdFormulario: 4, flObrigatorio: false, },

                            { cdEtapa: 17, cdFormulario: 0, flObrigatorio: false, },
                            { cdEtapa: 17, cdFormulario: 2, flObrigatorio: false, },

                            { cdEtapa: 18, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 18, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 18, cdFormulario: 2, flObrigatorio: true, },
                            { cdEtapa: 18, cdFormulario: 3, flObrigatorio: true, },
                            { cdEtapa: 18, cdFormulario: 4, flObrigatorio: true, },
                            { cdEtapa: 18, cdFormulario: 5, flObrigatorio: true, },

                            { cdEtapa: 19, cdFormulario: 0, flObrigatorio: false, },

                            { cdEtapa: 20, cdFormulario: 0, flObrigatorio: false, },
                            { cdEtapa: 20, cdFormulario: 5, flObrigatorio: false, },

                            { cdEtapa: 21, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 21, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 21, cdFormulario: 2, flObrigatorio: true, },
                            { cdEtapa: 21, cdFormulario: 3, flObrigatorio: true, },
                            { cdEtapa: 21, cdFormulario: 4, flObrigatorio: true, },
                            { cdEtapa: 21, cdFormulario: 5, flObrigatorio: true, },
                            { cdEtapa: 21, cdFormulario: 6, flObrigatorio: true, },
                            { cdEtapa: 21, cdFormulario: 7, flObrigatorio: true, },

                            { cdEtapa: 22, cdFormulario: 0, flObrigatorio: false, },
                            { cdEtapa: 22, cdFormulario: 1, flObrigatorio: false, },
                            { cdEtapa: 22, cdFormulario: 2, flObrigatorio: false, },
                            { cdEtapa: 22, cdFormulario: 3, flObrigatorio: false, },
                            { cdEtapa: 22, cdFormulario: 4, flObrigatorio: false, },
                            { cdEtapa: 22, cdFormulario: 5, flObrigatorio: false, },
                            { cdEtapa: 22, cdFormulario: 6, flObrigatorio: false, },
                        ],
                    },
                    {
                        cdModelo: 1,
                        cdLegislacao: 3,
                        lstCampos: [
                            // 'cdEtapa' para encontrar no banco
                            { cdEtapa: 23, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 23, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 24, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 25, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 25, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 26, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 26, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 27, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 27, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 28, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 28, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 29, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 29, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 30, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 30, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 46, cdFormulario: 0, flObrigatorio: false, },
                            { cdEtapa: 46, cdFormulario: 1, flObrigatorio: false, },
                        ]
                    },
                    {
                        cdModelo: 2,
                        cdLegislacao: 3,
                        lstCampos: [
                            { cdEtapa: 31, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 31, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 31, cdFormulario: 2, flObrigatorio: true, },
                            { cdEtapa: 31, cdFormulario: 3, flObrigatorio: true, },

                            { cdEtapa: 32, cdFormulario: 0, flObrigatorio: true, },

                            { cdEtapa: 33, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 33, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 33, cdFormulario: 4, flObrigatorio: true, },
                            { cdEtapa: 33, cdFormulario: 5, flObrigatorio: true, },
                            { cdEtapa: 33, cdFormulario: 6, flObrigatorio: true, },
                            { cdEtapa: 33, cdFormulario: 7, flObrigatorio: true, },
                            { cdEtapa: 33, cdFormulario: 8, flObrigatorio: true, },
                            { cdEtapa: 33, cdFormulario: 10, flObrigatorio: true, },
                            { cdEtapa: 33, cdFormulario: 13, flObrigatorio: true, },

                            { cdEtapa: 34, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 34, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 34, cdFormulario: 2, flObrigatorio: true, },
                            { cdEtapa: 34, cdFormulario: 3, flObrigatorio: true, },
                            { cdEtapa: 34, cdFormulario: 4, flObrigatorio: true, },
                            { cdEtapa: 34, cdFormulario: 5, flObrigatorio: true, },
                            { cdEtapa: 34, cdFormulario: 6, flObrigatorio: true, },
                            { cdEtapa: 34, cdFormulario: 7, flObrigatorio: true, },
                            { cdEtapa: 34, cdFormulario: 8, flObrigatorio: true, },
                            { cdEtapa: 34, cdFormulario: 9, flObrigatorio: true, },
                            { cdEtapa: 34, cdFormulario: 11, flObrigatorio: true, },
                            { cdEtapa: 34, cdFormulario: 13, flObrigatorio: true, },
                            { cdEtapa: 34, cdFormulario: 15, flObrigatorio: true, },
                            { cdEtapa: 34, cdFormulario: 17, flObrigatorio: true, },
                            { cdEtapa: 34, cdFormulario: 19, flObrigatorio: true, },
                            { cdEtapa: 34, cdFormulario: 20, flObrigatorio: true, },
                            { cdEtapa: 34, cdFormulario: 21, flObrigatorio: true, },

                            { cdEtapa: 35, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 35, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 35, cdFormulario: 2, flObrigatorio: true, },
                            { cdEtapa: 35, cdFormulario: 3, flObrigatorio: true, },
                            { cdEtapa: 35, cdFormulario: 4, flObrigatorio: true, },
                            { cdEtapa: 35, cdFormulario: 6, flObrigatorio: true, },

                            { cdEtapa: 36, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 36, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 36, cdFormulario: 2, flObrigatorio: true, },
                            { cdEtapa: 36, cdFormulario: 3, flObrigatorio: true, },

                            { cdEtapa: 37, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 37, cdFormulario: 13, flObrigatorio: true, },
                            { cdEtapa: 37, cdFormulario: 14, flObrigatorio: true, },

                            { cdEtapa: 38, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 38, cdFormulario: 2, flObrigatorio: true, },
                            { cdEtapa: 38, cdFormulario: 4, flObrigatorio: true, },

                            { cdEtapa: 39, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 39, cdFormulario: 2, flObrigatorio: true, },

                            { cdEtapa: 40, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 40, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 40, cdFormulario: 2, flObrigatorio: true, },
                            { cdEtapa: 40, cdFormulario: 3, flObrigatorio: true, },
                            { cdEtapa: 40, cdFormulario: 4, flObrigatorio: true, },
                            { cdEtapa: 40, cdFormulario: 5, flObrigatorio: true, },

                            { cdEtapa: 41, cdFormulario: 0, flObrigatorio: true, },

                            { cdEtapa: 42, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 42, cdFormulario: 5, flObrigatorio: true, },

                            { cdEtapa: 43, cdFormulario: 0, flObrigatorio: true, },
                            { cdEtapa: 43, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 43, cdFormulario: 2, flObrigatorio: true, },
                            { cdEtapa: 43, cdFormulario: 3, flObrigatorio: true, },
                            { cdEtapa: 43, cdFormulario: 4, flObrigatorio: true, },
                            { cdEtapa: 43, cdFormulario: 5, flObrigatorio: true, },
                            { cdEtapa: 43, cdFormulario: 6, flObrigatorio: true, },
                            { cdEtapa: 43, cdFormulario: 7, flObrigatorio: true, },

                            { cdEtapa: 44, cdFormulario: 0, flObrigatorio: false, },
                            { cdEtapa: 44, cdFormulario: 1, flObrigatorio: true, },
                            { cdEtapa: 44, cdFormulario: 2, flObrigatorio: true, },
                            { cdEtapa: 44, cdFormulario: 3, flObrigatorio: false, },
                            { cdEtapa: 44, cdFormulario: 4, flObrigatorio: true, },
                            { cdEtapa: 44, cdFormulario: 5, flObrigatorio: false, },
                            { cdEtapa: 44, cdFormulario: 6, flObrigatorio: true, },
                        ],
                    }
                ],
                manual: null,
            }
        },
        methods: {
            confirmarVoltarEtapa() {
                const etapa = this.ultimoTipoStatusHistorico || 'atual';
                const textoReenvio = this.ultimoCdStatusHistorico === '7'
                    ? 'Você poderá escolher novos assinantes ao reenviar.'
                    : 'Você poderá escolher novos revisores ou aprovadores ao reenviar.';
                Swal.fire({
                    title: 'Voltar etapa?',
                    html: `O artefato sairá de <strong>${etapa}</strong> e retornará ao status anterior. ${textoReenvio}`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d97706',
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Sim, voltar etapa',
                    reverseButtons: true,
                }).then(result => {
                    if (result.isConfirmed) this.voltarEtapa();
                });
            },

            confirmarCancelarProcessamento() {
                Swal.fire({
                    title: 'Cancelar processamento?',
                    html: 'O processamento em andamento será marcado como cancelado por possível travamento. Depois você poderá iniciar uma nova geração.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d97706',
                    cancelButtonText: 'Voltar',
                    confirmButtonText: 'Sim, cancelar processamento',
                    reverseButtons: true,
                }).then(result => {
                    if (result.isConfirmed) this.cancelarProcessamentoTravado();
                });
            },

            cancelarProcessamentoTravado() {
                if (this.cancelarProcessamentoLoading) return;
                this.cancelarProcessamentoLoading = true;
                axios.post(`${urlApi}/ProcessoArtefato/CancelarProcessamentoTravado`, {
                    idProcesso: parseInt(this.idProcesso, 10),
                    idProcessoModeloArtefato: parseInt(this.idProcessoModeloArtefato, 10),
                }, { showLoading: true })
                    .then((res) => {
                        if (res.data && res.data.success) {
                            avisoToast(res.data.msg || 'Processamento cancelado com sucesso.', 'success');
                            return Promise.all([
                                this.GetStatusProcessamento({ showLoading: false }),
                                this.GetProcessoArtefatoHistorico({ showLoading: false }),
                            ]);
                        }
                        avisoErro((res.data && res.data.msg) || 'Não foi possível cancelar o processamento.');
                        return null;
                    })
                    .then(() => {
                        this.$emit('atualizar');
                    })
                    .catch(err => {
                        const msg = (err.response && err.response.data && err.response.data.errors && err.response.data.errors[0])
                            || (err.response && err.response.data && err.response.data.msg)
                            || err.message
                            || 'Não foi possível cancelar o processamento.';
                        avisoErro(msg);
                    })
                    .finally(() => {
                        this.cancelarProcessamentoLoading = false;
                    });
            },

            GetStatusProcessamento(opts = {}) {
                const showLoading = opts.showLoading === true;
                return axios.get(`${urlApi}/ProcessoArtefato/GetStatusProcessamento/`, {
                    showLoading,
                    params: {
                        idProcesso: this.idProcesso,
                        idProcessoModeloArtefato: this.idProcessoModeloArtefato,
                    },
                })
                    .then(res => {
                        if (res.data && res.data.success) {
                            this.statusProcessamento = res.data.data || null;
                            this.atualizarMonitoramentoStatusProcessamento();
                        }
                    })
                    .catch(() => {
                        // silencioso: não bloqueia abertura da modal
                    });
            },

            atualizarMonitoramentoStatusProcessamento() {
                if (this.emProcessamentoArtefato) {
                    if (!this.intervaloStatusProcessamento) {
                        this.intervaloStatusProcessamento = setInterval(() => {
                            this.GetStatusProcessamento({ showLoading: false });
                        }, 30000);
                    }
                } else {
                    this.pararMonitoramentoStatusProcessamento();
                }
            },

            pararMonitoramentoStatusProcessamento() {
                if (this.intervaloStatusProcessamento) {
                    clearInterval(this.intervaloStatusProcessamento);
                    this.intervaloStatusProcessamento = null;
                }
            },

            voltarEtapa() {
                if (this.voltarEtapaLoading) return;
                this.voltarEtapaLoading = true;
                axios.post(`${urlApi}/ProcessoArtefatoStatusHistorico/VoltarEtapa`, {
                    idProcesso: parseInt(this.idProcesso, 10),
                    idProcessoModeloArtefato: parseInt(this.idProcessoModeloArtefato, 10),
                }, { showLoading: true })
                    .then((res) => {
                        if (res.data && res.data.success) {
                            avisoToast(res.data.msg || 'Etapa revertida com sucesso.', 'success');
                            return Promise.all([
                                this.GetProcessoArtefatoStatusHistorico({ showLoading: false }),
                                this.GetProcessoArtefatoHistorico({ showLoading: false }),
                            ]);
                        }
                        avisoErro((res.data && res.data.msg) || 'Não foi possível voltar a etapa.');
                        return null;
                    })
                    .then(() => {
                        this.$emit('atualizar');
                    })
                    .catch(err => {
                        const msg = (err.response && err.response.data && err.response.data.errors && err.response.data.errors[0])
                            || (err.response && err.response.data && err.response.data.msg)
                            || err.message
                            || 'Não foi possível voltar a etapa.';
                        avisoErro(msg);
                    })
                    .finally(() => {
                        this.voltarEtapaLoading = false;
                    });
            },

            getDataBsHistorico(item) {
                //let status = (item.status == "Finalizada" ? 'text-success' : 'text-danger');

                var resonse = ` <span class="mb-0"><strong>Tipo Envio:</strong> ${item.nmTipoEnvio}</span> 
  <span class="mb-0"><strong>Data:</strong> ${this.formatDate(item.dtInclusao)}</span> 
 <span class="mb-0"><strong>Usuário:</strong> ${item.nmUsuario}</span> `;

                if (item.dsStatus) {
                    if (item.nmTipoEnvio == 'Solicitar envio') {
                            resonse += `<p class="mb-0"><strong>Status:</strong> <strong class="${(item.dsStatus == 'Respondido' ? 'text-success' : 'text-primary') } fw-normal">${item.dsStatus}</strong></p>`
                    } else {
                        var classStatus = (item.dsStatus == 'Finalizada' ? 'text-success' : (item.dsStatus == 'Cancelada' ? 'text-danger' : 'text-primary'))
                        resonse += `<p class="mb-0"><strong>Status:</strong> <strong class="${classStatus} fw-normal">${item.dsStatus}</strong></p>`
                    }
                }
                if (item.dsDetalhes) {
                    resonse += `<p class="mb-0"><strong>Detalhes:</strong> ${item.dsDetalhes}</p>`
                }
                if (item.nmModelo) {
                    resonse += `<p class="mb-0"><strong>Modelo:</strong> ${item.nmModelo}</p>`
                }

                return resonse;
            },

            montaPopover() {
                var popovers = document.querySelectorAll(".popover");
                // Itera sobre cada elemento e remove-o
                popovers.forEach(function (popover) {
                    popover.remove();
                });

                this.$nextTick(function () {
                    var popoverTriggerList = document.querySelectorAll(
                        '[data-bs-toggle="popover"]',
                    );// eslint-disable-line no-console

                    if (popoverTriggerList.length > 0) {
                        [].slice
                            .call(popoverTriggerList)
                            .map(function (popoverTriggerEl) {
                                return new window.bootstrap.Popover(popoverTriggerEl, {
                                    trigger: "hover",
                                    boundary: "window",
                                    html: true,
                                    customClass: 'custom-popover'
                                    //placement: "right",
                                });
                            });
                    }
                });
            },

            montaManual() {
                if (this.processoModeloArtefato.nmModelo == "Documento de Formalização de Demanda (DFD)") {
                    this.manual = {
                        name: 'Manual DFD',
                        nameBtn: 'Manual',
                        urlPdf: '/manuais/Manual do DFD.pdf',
                    };
                }

                if (this.processoModeloArtefato.nmModelo == "Estudo Técnico Preliminar (ETP)") {
                    this.manual = {
                        name: 'Manual ETP',
                        nameBtn: 'Manual',
                        urlPdf: '/manuais/Manual do ETP.pdf',
                    };
                }
            },

            confirmarGeracaoIAAssistente(idModeloArtefato) {
                Swal.fire({
                    title: 'Confirmar geração por IA',
                    html: `Esta ação utilizará inteligência artificial para gerar automaticamente um <strong>${this.processoModeloArtefato?.nmModelo}</strong> com base nos documentos enviados.<br><br>
                           Deseja continuar?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#1f7bff',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, gerar por IA',
                    cancelButtonText: 'Cancelar'
                  
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(`${urlApi}/ProcessoArtefato/GerarIAAssistente`, {
                            idProcesso: this.idProcesso,
                            idProcessoModeloArtefato: this.idProcessoModeloArtefato,
                            idModeloArtefato: idModeloArtefato
                        }).then(res => {
                            if (res.data.success) {
                                avisoToast(`Processamento do ${this.processoModeloArtefato?.nmModelo} registrado com sucesso. Você será notificado quando estiver concluído.`);
                                this.load();
                            } else {
                                avisoErro(res.data.msg || "Erro inesperado.");
                            }
                        }).catch(err => {
                            const msg = err?.response?.data?.msg || err.message || "Erro ao gerar por IA.";
                            const extra = err?.response?.data?.errors?.[0] || '';
                            avisoErro(`${msg} ${extra}`);
                        });
                    }
                });
            },

            load() {
                this.manual = null;
                Promise.all([
                    this.GetProcessoArtefatoHistorico(),
                    this.GetProcessoArtefatoStatusHistorico(),
                    this.GetStatusProcessamento({ showLoading: false }),
                    this.getUsuariosResponsavel(),
                    this.getResponsavel(),
                ]).then(() => {
                    this.ensureResponsavelInList();
                    this.isReadyForAutosave = true;
                });
            },

            GetProcessoArtefatoHistorico(opts = {}) {
                const showLoading = opts.showLoading !== false;
                let $this = this;
                return axios.get(`${urlApi}/ProcessoArtefato/GetProcessoArtefatoHistorico/`, { showLoading, params: { idProcesso: this.idProcesso, idProcessoModeloArtefato: this.idProcessoModeloArtefato } } )
                    .then(res => {
                        $this.lstProcessoArtefatoHistorico = null;
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.processoArtefato = result.processoArtefato;
                            $this.processoArtefatoAssistente = result.processoArtefatoAssistente;
                            $this.processoModeloArtefato = result.processoModeloArtefato;
                            $this.processoModeloArtefatoConfiguracao = result.processoModeloArtefatoConfiguracao;

                            $this.lstTiposEnvios = result.lstTiposEnvios;
                            $this.lstProcessoArtefatoHistorico = result.lstProcessoArtefatoHistorico;

                            $this.lstFormulario = result.lstModeloArtefatoFormularioEtapa;
                            $this.flTemFormulario = $this.lstFormulario != null && $this.lstFormulario.length > 0;
                            
                            $this.montaPopover();
                            $this.montaManual();
                            
                        } else {
                            avisoErro("Não foi possível carregar os dados.");
                        }
                    })
                    .catch(res => {
                        if (res.response?.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro("Não foi possível carregar os dados.");
                        }
                    });
            },

            getDataBsHistoricoStatus(item) {
                let html = `<p class="mb-0"><strong>Status:</strong> ${item.nmTipoStatusHistorico || '—'}</p>
                            <p class="mb-0"><strong>Data:</strong> ${this.formatDate(item.dtInclusao)}</p>
                            <p class="mb-0"><strong>Responsável:</strong> ${item.nmUsuario || '—'}</p>`;

                if (item.dsTipoStatusHistorico) {
                    html += `<p class="mb-0"><strong>Detalhe:</strong> ${item.dsTipoStatusHistorico}</p>`;
                }

                return html;
            },

            GetProcessoArtefatoStatusHistorico(opts = {}) {
                const showLoading = opts.showLoading !== false;
                let $this = this;
                return axios.get(`${urlApi}/ProcessoArtefatoStatusHistorico/GetProcessoArtefatoStatusHistorico/`, {
                    showLoading,
                    params: { idProcesso: this.idProcesso, idProcessoModeloArtefato: this.idProcessoModeloArtefato }
                })
                    .then(res => {
                        $this.lstProcessoArtefatoStatusHistorico = null;
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.lstProcessoArtefatoStatusHistorico = result;
                            $this.montaPopover();
                            $this.verificarStatusAssinado();
                        } else {
                            avisoErro("Não foi possível carregar os dados.");
                        }
                    })
                    .catch(res => {
                        if (res.response?.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro("Não foi possível carregar os dados.");
                        }
                    });
            },

            verDocumentoRevisado() {
                const id = String(this.idProcessoArtefatoValue || this.processoArtefato?.idProcessoArtefato);
                if (this.myModalAlternative) this.myModalAlternative.hide();
                this.$emit('ver-documento');
                const rota = this.ultimoCdStatusHistorico === '7'
                    ? 'ProcessoAssinatura'
                    : 'ProcessoRevisado';
                this.$nextTick(() => {
                    this.$router.push({ name: rota, params: { id } });
                });
            },

            abrirInteracaoIa() {
                const id = String(this.processoArtefato?.idProcessoArtefato);
                if (!id) return;
                if (this.myModalAlternative) this.myModalAlternative.hide();
                this.$nextTick(() => {
                    this.$router.push({ name: 'ProcessoArtefatoInteracao', params: { id } });
                });
            },

            retificarDocumento() {
                if (this.myModalAlternative) {
                    this.myModalAlternative.hide();
                }

                setTimeout(() => {
                    this.ModalRetificarDocumento = new window.bootstrap.Modal('#ModalRetificarDocumento');
                    this.ModalRetificarDocumento.show();
                }, 100);
            },

            downloadAtual(idProcessoArtefato, urlArquivo) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    nmArquivo = nomeArquivo[nomeArquivo.length - 1];
                }
                axios({
                    url: `${urlApi}/ProcessoArtefato/Download/${idProcessoArtefato}`, //your url
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then(response => {
                        // create file link in browser's memory
                        const href = URL.createObjectURL(response.data);

                        // create "a" HTML element with href to file & click
                        const link = document.createElement('a');
                        link.href = href;
                        link.setAttribute('download', nmArquivo); //or any other extension
                        document.body.appendChild(link);
                        link.click();

                        // clean up "a" element & remove ObjectURL
                        document.body.removeChild(link);
                        URL.revokeObjectURL(href);
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            downloaHistorico(idProcessoAtefatoHistorico, urlArquivo) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    nmArquivo = nomeArquivo[nomeArquivo.length - 1];
                }
                axios({
                    url: `${urlApi}/ProcessoArtefato/DownloadHistorico/${idProcessoAtefatoHistorico}`, //your url
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then(response => {
                        // create file link in browser's memory
                        const href = URL.createObjectURL(response.data);

                        // create "a" HTML element with href to file & click
                        const link = document.createElement('a');
                        link.href = href;
                        link.setAttribute('download', nmArquivo); //or any other extension
                        document.body.appendChild(link);
                        link.click();

                        // clean up "a" element & remove ObjectURL
                        document.body.removeChild(link);
                        URL.revokeObjectURL(href);
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            verificarStatusAssinado() {
                const arr = this.lstProcessoArtefatoStatusHistorico;
                if (!Array.isArray(arr) || !arr.length) return;

                const temAssinado = arr.some(st => {
                    const cd = st.cdTipoStatusHistorico ?? st.idTipoStatusHistorico;
                    return String(cd) === '8';
                });

                if (temAssinado) {
                    this.getProcessoAssinatura();
                }
            },

            getProcessoAssinatura() {
                const idProcessoArtefato = this.idProcessoArtefatoValue;

                if (!idProcessoArtefato) {
                    console.warn('Sem idProcessoArtefato para buscar ProcessoAssinatura.');
                    return;
                }

                let $this = this;
                axios.get(`${urlApi}/ProcessoAssinatura/Get`, {
                    params: { idProcessoArtefato: idProcessoArtefato }
                })
                    .then(res => {
                        if (res?.data?.success) {
                            const rows = res.data.data.rows || [];
                            if (rows.length > 0) {
                                const item = rows[0];
                                $this.ProcessoAssinatura = item.processo || null;
                            }
                        } else {
                            console.warn('Resposta sem sucesso ao buscar ProcessoAssinatura');
                        }
                    })
                    .catch(err => {
                        console.error('Erro ao fazer requisição ProcessoAssinatura/Get:', err);
                        avisoToast('Erro ao carregar processos de assinatura!', 'warning');
                    });
            },

            downloadAssinado() {
                const p = this.ProcessoAssinatura || {};
                const idProcessoCertificadora = p.idProcessoCertificadora;
                const idDocumentoCertificadora = p.idDocumentoCertificadora;

                if (!idProcessoCertificadora || !idDocumentoCertificadora) {
                    avisoErro('Dados da assinatura não encontrados para este artefato.');
                    return;
                }

                axios({
                    url: `${urlApi}/ProcessoAssinatura/GetDocumentoAssinado`,
                    method: 'GET',
                    responseType: 'blob',
                    params: {
                        idProcessoCertificadora,
                        idDocumentoCertificadora
                    }
                })
                    .then(response => {
                        const contentDisposition = response.headers['content-disposition'] || '';
                        let fileName = 'documento-assinado.pdf';

                        const match = contentDisposition.match(/filename="?([^"]+)"?/i);
                        if (match && match[1]) {
                            fileName = match[1];
                        }

                        const href = URL.createObjectURL(response.data);

                        const link = document.createElement('a');
                        link.href = href;
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();

                        document.body.removeChild(link);
                        URL.revokeObjectURL(href);
                    })
                    .catch(err => {
                        console.error(err);
                        const msg = err?.response?.data || err.message || 'Erro ao baixar documento assinado.';
                        avisoErro(msg);
                    });
            },

            hideModalFn() {
                //const myModalAlternative = new window.bootstrap.Modal('#ModalProcessoArtefato');
                this.myModalAlternative.hide();
            },

            formatDate(dt) {
                return moment(dt).format('DD/MM/YYYY [às] HH:mm')
            },

            acaoTipoEnvio(tipoEnvio) {
                if (this.acoesDesabilitadas) { avisoErro(this.motivoBloqueio || 'Ação indisponível no momento.'); return; }
                switch (tipoEnvio.cdTipoEnvio) {
                    case "UP": this.showUpload(); break;
                    case "SE": this.showSolicitacaoEnvio(); break;
                    case "GI": this.showArtefatoFormulario(); break;
                    case "G2": this.gerarIAAssistente(); break;
                    case "GA": this.showEnvioArquivoProcessamento(); break;
                }
            },

            abreFormulario() {
                //if (this.acoesDesabilitadas) { avisoErro(this.motivoBloqueio || 'Ação indisponível no momento.'); return; }
                if (this.componenteFormulario != null) {
                    if (this.myModalAlternative) {
                        this.myModalAlternative.hide();
                    }
                    this.camposInvalidos = {};

                    setTimeout(() => {
                        this.ModalArtefatoFormulario = new window.bootstrap.Modal('#ModalFormulario');
                        this.ModalArtefatoFormulario.show();

                        const modalFormularioEl = document.getElementById('ModalFormulario');
                        if (modalFormularioEl) {
                            modalFormularioEl.addEventListener('hidden.bs.modal', () => {
                                this.myModalAlternative.show();
                            }, { once: true });
                        }
                    }, 100);
                } else {
                    avisoToast("Formulário de criação do artefato não disponível", "error");
                }
                
            },

            showUpload() {
                if (this.estaBloqueado) { avisoErro(this.motivoBloqueio); return; }
                if (this.myModalAlternative) {
                    this.myModalAlternative.hide();
                }

                setTimeout(() => {
                    this.ModalUpload = new window.bootstrap.Modal('#ModalUpload');
                    this.ModalUpload.show();
                }, 100);
            },

            async getUsuariosResponsavel() {
                let $this = this;
                try {
                    const { data } = await axios.get(`${urlApi}/ProcessoPermissao/GetUsuariosContrato/`, { showLoading: false });
                    if (data.success) {
                        const rows = data.data || [];
                        if (rows.length > 0) {
                            $this.lstUsuariosResponsavel = (data.data || []).map(u => ({
                                ...u,
                                isOwner: u.dsLogin === $this.dsLoginProprietario
                            }));
                        } else {
                            await this.getUsuarioInternoAtual();
                        }
                    } else {
                        $this.lstUsuariosResponsavel = [];
                    }
                } catch (err) {
                    $this.lstUsuariosResponsavel = [];
                    avisoErro(err.response?.data || err.message || 'Erro ao carregar usuários do contrato.');
                }
            },

            async getUsuarioInternoAtual() {
                try {
                    const res = await axios.get(`${urlApi}/ProcessoPermissao/GetUsuariosInternosAtuais/`, { showLoading: false });

                    if (res.data?.success && Array.isArray(res.data.data)) {

                        const lista = res.data.data.map(item => ({
                            ...item,
                            isOwner: item.dsLogin === this.dsLoginProprietario
                        }));

                        this.lstUsuariosResponsavel = lista;

                    } else {
                        avisoErro(res.data?.msg || "Não foi possível carregar o(s) usuário(s) interno(s).");
                    }
                } catch (err) {
                    avisoErro(err?.response?.data || "Não foi possível carregar o usuário interno.");
                }
            },

            isOwner(login) {
                return login && login === this.dsLoginProprietario;
            },

            async garantirPermissoesResponsavel(dsLogin) {
                if (this.isOwner(dsLogin)) return;

                const payload = {
                    idProcessoPermissao: null,
                    idProcesso: parseInt(this.idProcesso),
                    dsLogin: dsLogin,
                    lstPermissoes: [1, 2, 3, 4].map(id => ({ Item1: id, Item2: true })),
                };

                try {
                    const res = await axios.post(`${urlApi}/ProcessoPermissao/PostEdicao`, payload);
                    if (!res.data.success) {
                        avisoErro(res.data.msg || `Erro ao salvar permissões do responsável ${dsLogin}`);
                    }
                } catch (err) {
                    avisoErro(err.response?.data || err.message || `Erro ao aplicar permissões a ${dsLogin}`);
                }
            },

            async checarPermissoesResponsavel(dsLogin) {
                if (this.isOwner(dsLogin)) return { hasAll: true, missing: [] };

                try {
                    const { data } = await axios.get(`${urlApi}/ProcessoPermissao/GetGridProcesso/${this.idProcesso}`, { showLoading: false });
                    if (!data?.success) return { hasAll: false, missing: [1, 2, 3, 4] };

                    const registros = data.data || [];
                    const registroUser = registros.find(r => r?.usuario?.dsLogin === dsLogin);
                    if (!registroUser) return { hasAll: false, missing: [1, 2, 3, 4] };

                    const ativos = new Set((registroUser.lstProcessoPermissao || []).map(p => p.idTipoPermissao));
                    const missing = [1, 2, 3, 4].filter(id => !ativos.has(id));

                    return { hasAll: missing.length === 0, missing };
                } catch {
                    return { hasAll: false, missing: [1, 2, 3, 4] };
                }
            },

            async salvarResponsavel() {
                if (!this.flProprietario) { avisoErro('Somente o proprietário pode alterar.'); return; }
                if (!this.responsavelLogin) { avisoErro('Selecione um responsável.'); return; }

                await this.garantirPermissoesResponsavel(this.responsavelLogin);

                const { hasAll } = await this.checarPermissoesResponsavel(this.responsavelLogin);
                if (!hasAll) {
                    avisoErro('Não foi possível garantir todas as permissões. Atualize a página e tente novamente.');
                    return;
                }

                await this.persistResponsavelPrazo({ dsLogin: this.responsavelLogin, force: true });
                this.$emit('atualizar');
                avisoToast('Responsável salvo e permissões garantidas.');
            },

            limitarAno(e) {
                const val = e.target.value || '';
                const m = val.match(/^(\d+)(-?.*)?$/);
                if (m) {
                    const ano4 = m[1].slice(0, 4);
                    const resto = m[2] || '';
                    const normalizado = ano4 + resto;
                    if (normalizado !== val) { 
                        this.dataLimiteDate = normalizado;
                    }
                }
            },

            async getResponsavel() {
                try {
                    const { data } = await axios.get(`${urlApi}/ProcessoArtefatoResponsavel/Get`, {
                        showLoading: true,
                        params: {
                            idProcesso: this.idProcesso,
                            idProcessoModeloArtefato: this.idProcessoModeloArtefato
                        }
                    });

                    if (!data?.success) {
                        avisoErro(data?.msg || 'Erro ao carregar responsável.');
                        this.idProcessoArtefatoResponsavel = null;
                        this.responsavelLogin = "";
                        this.dataLimiteDate = "";
                        return;
                    }

                    const rows = data.data.rows;
                    const wrapper = Array.isArray(rows) && rows.length ? rows[0] : null;
                    const registro = wrapper?.processoArtefatoResponsavel || null;

                    if (registro) {
                        this.idProcessoArtefatoResponsavel = registro.idProcessoArtefatoResponsavel || null;
                        this.responsavelLogin = registro.dsLogin || "";

                        const iso = (registro.dtLimite || "").substring(0, 10);

                        // se vier DateTime.MinValue do back, trata como "sem data"
                        if (iso === "0001-01-01" || iso === "1901-01-01") {
                            this.dataLimiteDate = "";
                        } else {
                            this.dataLimiteDate = iso;
                        }
                    } else {
                        this.idProcessoArtefatoResponsavel = null;
                        this.responsavelLogin = "";
                        this.dataLimiteDate = "";
                    }
                } catch (err) {
                    avisoErro(err?.response?.data || err.message || 'Erro desconhecido');
                    this.idProcessoArtefatoResponsavel = null;
                    this.responsavelLogin = "";
                    this.dataLimiteDate = "";
                }
            },


            showArtefatoFormulario() {
                if (this.estaBloqueado) { avisoErro(this.motivoBloqueio); return; }
                if (this.flTemFormulario) {
                    if (this.myModalAlternative) {
                        this.myModalAlternative.hide();
                    }
                    this.camposInvalidos = {};

                    setTimeout(() => {
                        this.ModalArtefatoFormulario = new window.bootstrap.Modal('#ModalFormulario');
                        this.ModalArtefatoFormulario.show();

                        const modalFormularioEl = document.getElementById('ModalFormulario');
                        if (modalFormularioEl) {
                            modalFormularioEl.addEventListener('hidden.bs.modal', () => {
                                this.myModalAlternative.show();
                            }, { once: true }); 
                        }
                    }, 100);
                } else {
                    avisoToast("Formulário de criação do artefato não disponível", "error");
                }
            },

            showSolicitacaoEnvio() {
                if (this.estaBloqueado) { avisoErro(this.motivoBloqueio); return; }
                const modalEl = document.getElementById('ModalProcessoArtefato');
                if (modalEl) {
                    modalEl.setAttribute('inert', 'true');
                }

                Swal.fire({
                    title: "Qual o email que deseja enviar a solicitação?",
                    input: "email",
                    inputAttributes: {
                        autocapitalize: "off"
                    },
                    showCancelButton: true,
                    confirmButtonColor: '#2563EB',
                    cancelButtonText: "Cancelar",
                    confirmButtonText: "Enviar",
                    showLoaderOnConfirm: true,
                    reverseButtons: true,
                    preConfirm: async (emailDestino) => {
                        if (!emailDestino || emailDestino.trim() === "") {
                            Swal.showValidationMessage("O e-mail é obrigatório.");
                            return false;
                        }

                        try {
                            const response = await axios.post(`${urlApi}/ProcessoArtefatoSolicitacaoEnvio/SolicitarEnvio`, {
                                idProcesso: this.idProcesso,
                                idProcessoModeloArtefato: this.idProcessoModeloArtefato,
                                dsLoginDestino: emailDestino
                            });

                            if (!response.data.success) {
                                throw new Error(response.data.msg || "Erro ao solicitar envio.");
                            }

                            return response.data;
                        } catch (err) {
                            Swal.showValidationMessage(`Erro: ${err.message}`);
                            return false;
                        }
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (modalEl) {
                        modalEl.removeAttribute('inert');
                    }

                    if (result.isConfirmed) {
                        avisoToast("Solicitação enviada com sucesso!");
                        this.load();
                    }
                }).catch(() => {
                    if (modalEl) {
                        modalEl.removeAttribute('inert');
                    }
                });
            },

            setUploadFile(urlArquivoS3) {
                this.urlArquivoS3 = urlArquivoS3.key;
                this.fileName = urlArquivoS3.fileName;
            },

            deleteUploadFile() {
                this.urlArquivoS = null;
                this.fileName = null;
            },

            setUploadFileProcessamento(arquivos) {
                if (!arquivos) {
                    this.lstArquivosProcessamento = [];
                    return;
                }
                this.lstArquivosProcessamento = Array.isArray(arquivos) ? arquivos.slice() : [arquivos];
            },

            deleteUploadFileProcessamento(hash) {
                this.lstArquivosProcessamento = this.lstArquivosProcessamento.filter(obj => obj.hash !== hash);
            },

            enviarUpload() {
                let $this = this;
                if (this.urlArquivoS3) {

                    axios.post(`${urlApi}/ProcessoArtefato/Upload`, { idProcesso: $this.idProcesso, idProcessoModeloArtefato: $this.idProcessoModeloArtefato, key: $this.urlArquivoS3, fileName: $this.fileName })
                        .then(res => {
                            if (res.data.success) {
                                $this.deleteUploadFile();
                                $this.reset = !$this.reset;
                                avisoToast("Artefato registrado com sucesso.");
                                $this.load();
                                $this.$emit('atualizar')
                                $this.ModalUpload.hide();
                            } else {
                                avisoErro("Não foi possível enviar o Artefato.");
                            }
                        })
                        .catch(res => {
                            if (res.response.data) {
                                $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                                avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);
                            } else {
                                avisoErro("Não foi possível enviar o Artefato.");
                            }
                        });
                } else {
                    avisoErro("Nenhum arquivo selecionado.");
                }

                return false;
            },

            enviaFormulario() {
                if (this.acoesDesabilitadas) { avisoErro(this.motivoBloqueio || 'Ação indisponível no momento.'); return; }
                let $this = this;
                Swal.fire({
                    title: 'Gerar Artefato?',
                    html: `Antes de prosseguir, <strong>recomendamos que você confira se o dados do formulário estão corretamente preenchidos.</strong><br><br>
                            Essa ação iniciará o processamento do seu Artefato.<br><br>
                            Deseja continuar?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#2563EB',
                    cancelButtonColor: '#6E7881',
                    confirmButtonText: 'Sim, Gerar Artefato',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        const formData2 = new FormData();

                        formData2.append("form.idProcesso", $this.idProcesso);
                        formData2.append("form.idProcessoModeloArtefato", $this.idProcessoModeloArtefato);
                        formData2.append("form.idModeloArtefato", $this.processoModeloArtefatoConfiguracao.idModeloArtefato);

                        let cont = 0;
                        $this.lstValidacaoForm.find(x => x.cdModelo == $this.processoModeloArtefato.cdModelo && x.cdLegislacao == Number($this.cdLegislacao)).lstCampos.forEach((item) => {
                            formData2.append("form.lstFormValidacao[" + cont +"].cdEtapa", item.cdEtapa);
                            formData2.append("form.lstFormValidacao[" + cont +"].cdFormulario", item.cdFormulario);
                            formData2.append("form.lstFormValidacao[" + cont +"].flObrigatorio", item.flObrigatorio);
                            cont++;
                        });

                        axios.post(`${urlApi}/ProcessoArtefato/GerarIAFormulario`, formData2, { headers: { "Content-Type": `multipart/form-data; boundary=${formData2._boundary}`, } })
                            .then(res => {
                                if (res.data.success) {
                                    avisoToast("Processamento do Artefato registrado com sucesso, você será notificado quando estiver concluído.");

                                    $this.load();
                                    $this.$emit('atualizar')
                                    $this.closeFormulario();
                                } else {
                                    $this.flReprocessar = true;
                                    avisoErro("Não foi possível enviar o artefato.");
                                }
                            })
                            .catch(res => {
                                $this.msgErro = 'Não foi possível enviar o artefato.';
                                if (res.response.data) {
                                    $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                                    avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);
                                } else {
                                    avisoErro("Não foi possível enviar o artefato.");
                                }
                            });
                    }
                });
            },

            enviarRetificacao() {
                let $this = this;
                if (this.dsMotivoRetificacao && $this.dsMotivoRetificacao != "" && $this.dsMotivoRetificacao.length > 0) {
                    $this.validacaoMotivoRetificacao = false;
                    if (this.urlArquivoS3) {             
                        const id = String(this.idProcessoArtefatoValue || this.processoArtefato?.idProcessoArtefato);
                        axios.post(`${urlApi}/ProcessoArtefatoRetificacao/Post`, { dsMotivo: $this.dsMotivoRetificacao, idProcessoArtefato: id, key: $this.urlArquivoS3, fileName: $this.fileName })
                            .then(res => {
                                if (res.data.success) {
                                    $this.deleteUploadFile();
                                    $this.reset = !$this.reset;
                                    avisoToast("Artefato retificado com sucesso.");
                                    $this.load();
                                    $this.$emit('atualizar')
                                    $this.ModalRetificarDocumento.hide();
                                } else {
                                    avisoErro("Não foi possível retificar o Artefato.");
                                }
                            })
                            .catch(res => {
                                if (res.response.data) {
                                    $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                                    avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);
                                } else {
                                    avisoErro("Não foi possível retificar o Artefato.");
                                }
                            });
                    } else {
                        avisoErro("Nenhum arquivo selecionado.");
                    }
                } else {
                    $this.validacaoMotivoRetificacao = true;
                    avisoToast("Motivo da retificação obrigatório.",'warning');
                }               

                return false;
            },

            closeFormulario() {
                this.ModalArtefatoFormulario.hide();
            },

            InitSignalR() {
                try {
                    let $this = this;

                    $this.hubConection.on("RecebeNotificacaoProcessoArtefato", function (idProcessoArtefato) {
                        if (idProcessoArtefato == $this.idProcessoArtefatoValue()) {
                            //$this.load();
                            $this.GetProcessoArtefatoHistorico();
                            $this.GetProcessoArtefatoStatusHistorico();
                            //console.log("Processamento finalizado");
                        }
                        
                    });

                    $this.hubConection.on("RecebeNotificacaoProcessoArtefatoPorProcesso", function (idProcesso, idProcessoModeloArtefato) {
                        if (idProcesso == $this.idProcesso && idProcessoModeloArtefato == $this.idProcessoModeloArtefato) {
                            $this.GetProcessoArtefatoHistorico();
                            $this.GetProcessoArtefatoStatusHistorico();
                        }
                    });
                }
                catch (ex) {
                    //console.log(ex);
                }
            },
            abrirLink(hash) {
                window.open('/SolicitacaoEnvio?hash=' + hash,'_blank')
            },

            reprocessar(idProcessoArtefato) {
                let $this = this;
                axios.post(`${urlApi}/ProcessoArtefato/Reprocessar`, { idProcessoArtefato: idProcessoArtefato })
                    .then(res => {
                        if (res.data.success) {
                            avisoToast("Artefato reprocessado.");
                            $this.load();
                        } else {
                            avisoErro("Não foi possível reprocessar o artefato.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data) {
                            $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                            avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);
                        } else {
                            avisoErro("Não foi possível reprocessar o artefato.");
                        }
                    });
            },

            abrirModalMatrizRiscos() {
                if (this.myModalAlternative) {
                    this.myModalAlternative.hide();
                }

                this.$nextTick(() => {
                    this.$refs.modalMatrizRiscos.abrir();
                });
            },

            VerificaArtefatos() {
                return axios.get(`${urlApi}/ProcessoArtefato/GetArtefatos`, {
                    params: {
                        idProcesso: this.idProcesso
                    }
                })
                    .then(res => {
                        if (!res.data.success || !res.data.data) {
                            avisoErro("Erro ao buscar os artefatos do processo.");
                            return false;
                        }

                        const artefatos = res.data.data || [];
                        if (artefatos.length === 0) {
                            avisoErro("Para realizar a geração por IA, é necessário o upload dos documentos DFD e ETP nos artefatos do processo.");
                            return false;
                        }

                        const temDFD = artefatos.some(a => a.idProcessoModeloArtefato === 1);
                        //const temETP = artefatos.some(a => a.idProcessoModeloArtefato === 2);
                        const temETP = true;

                        if (!temDFD || !temETP) {
                            let faltando = [];
                            if (!temDFD) faltando.push("DFD");
                            if (!temETP) faltando.push("ETP");

                            avisoErro(`Ainda faltam os seguintes documentos para permitir a geração por IA: ${faltando.join(" e ")}.`);
                            return false;
                        }

                        return true;
                    })
                    .catch(() => {
                        avisoErro("Erro na requisição de verificação de artefatos.");
                        return false;
                    });
            },

abrirSwalSelecaoModelo(title, inputOptions) {
                const modalEl = document.getElementById('ModalProcessoArtefato');
                if (modalEl) {
                    modalEl.setAttribute('inert', 'true');
                }

                const liberarModal = () => {
                    if (modalEl) {
                        modalEl.removeAttribute('inert');
                    }
                };

                return Swal.fire({
                    title,
                    input: 'select',
                    inputOptions,
                    inputPlaceholder: 'Escolha um modelo',
                    showCancelButton: true,
                    confirmButtonText: 'Continuar',
                    cancelButtonText: 'Cancelar',
                    confirmButtonColor: '#2563EB',
                    allowOutsideClick: false,
                    allowEnterKey: false,
                    allowEscapeKey: true,
                    willOpen: () => {
                        document.activeElement?.blur?.();
                    },
                    didOpen: () => {
                        setTimeout(() => document.activeElement?.blur?.(), 50);
                    }
                }).then(result => {
                    liberarModal();
                    if (result.isConfirmed && result.value) {
                        this.confirmarGeracaoIAAssistente(parseInt(result.value));
                    }
                }).catch(() => {
                    liberarModal();
                });
            },

            async gerarIAAssistente() {
                const podeGerar = await this.VerificaArtefatos();
                if (!podeGerar) return;

                //const isEdital = this.processoModeloArtefato?.nmModelo === 'Edital';
                let cdModelo = this.processoModeloArtefato?.cdModelo;
                switch (cdModelo) {
                    case 4:
                        // termo de referencia
                        if (!this.termoRefenrencia.length) await this.getModeloTermoReferencia();
                        this.abrirSwalSelecaoModelo(
                            'Selecione o modelo do Termo de Referência',
                            this.termoRefenrencia.reduce((map, item) => {
                                map[item.modeloArtefato.idModeloArtefato] = item.modeloArtefato.nmModelo;
                                return map;
                            }, {})
                        );
                        break;

                    case 5:
                    case 46:
                        // edital
                        if (!this.editais.length) await this.getModeloEdital();
                        this.abrirSwalSelecaoModelo(
                            'Selecione o modelo de edital',
                            this.editais.reduce((map, edital) => {
                                map[edital.modeloArtefato.idModeloArtefato] = edital.modeloArtefato.nmModelo;
                                return map;
                            }, {})
                        );
                        break;

                    case 10:
                        // termo de contrato
                        if (!this.lstTermoContrato.length) await this.getModeloTermoContrato();
                        this.abrirSwalSelecaoModelo(
                            'Selecione o modelo de Termo de Contrato',
                            this.lstTermoContrato.reduce((map, item) => {
                                map[item.modeloArtefato.idModeloArtefato] = item.modeloArtefato.nmModelo;
                                return map;
                            }, {})
                        );
                        break;

                    case 9:
                        // parecer parametrizado
                        if (!this.lstParecerParametrizado.length) await this.getModeloParecerParametrizado();
                        this.abrirSwalSelecaoModelo(
                            'Selecione o modelo de Parecer',
                            this.lstParecerParametrizado.reduce((map, item) => {
                                map[item.modeloArtefato.idModeloArtefato] = item.modeloArtefato.nmModelo;
                                return map;
                            }, {})
                        );
                        break;

                    default:
                        // direto no idModeloArtefato
                        if (this.processoModeloArtefatoConfiguracao?.idModeloArtefato > 0) {
                            this.confirmarGeracaoIAAssistente(this.processoModeloArtefatoConfiguracao.idModeloArtefato);
                        } else {
                            avisoToast("Geração do artefato por IA não disponível", "error");
                        }
                        break;
                }
            },

            getModeloEdital() {
                let $this = this;
                axios.get(`${urlApi}/Modelo/GetEdital`, { params: { idLegislacaoModeloArtefato: this.idLegislacao }})
                    .then(res => {
                        if (res.data.success) {
                            $this.editais = res.data.data.rows;
                        } else {
                            avisoErro(res.data.msg || 'Erro ao carregar processo.');
                        }
                    })
                    .catch(err => {
                        avisoErro(err?.response?.data || err.message || 'Erro desconhecido');
                    });
            },

            getModeloTermoReferencia() {
                let $this = this;
                axios.get(`${urlApi}/Modelo/GetModelosProcessoInteligente`, { params: { idLegislacaoModeloArtefato: this.idLegislacao, termo: "Termo de Ref" } })
                    .then(res => {
                        if (res.data.success) {
                            $this.termoRefenrencia = res.data.data.rows;
                        } else {
                            avisoErro(res.data.msg || 'Erro ao carregar processo.');
                        }
                    })
                    .catch(err => {
                        avisoErro(err?.response?.data || err.message || 'Erro desconhecido');
                    });
            },

            getModeloTermoContrato() {
                let $this = this;
                axios.get(`${urlApi}/Modelo/GetModelosProcessoInteligente`, { params: { idLegislacaoModeloArtefato: this.idLegislacao, termo : "Termo de Contrato" } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstTermoContrato = res.data.data.rows;
                        } else {
                            avisoErro(res.data.msg || 'Erro ao carregar processo.');
                        }
                    })
                    .catch(err => {
                        avisoErro(err?.response?.data || err.message || 'Erro desconhecido');
                    });
            },

            getModeloParecerParametrizado() {
                let $this = this;
                axios.get(`${urlApi}/Modelo/GetModelosProcessoInteligente`, { params: { idLegislacaoModeloArtefato: this.idLegislacao, termo: "Parecer" } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstParecerParametrizado = res.data.data.rows;
                        } else {
                            avisoErro(res.data.msg || 'Erro ao carregar processo.');
                        }
                    })
                    .catch(err => {
                        avisoErro(err?.response?.data || err.message || 'Erro desconhecido');
                    });
            },

            async limparResponsavel() {
                if (!this.flProprietario) { avisoErro('Somente o proprietário pode alterar.'); return; }
                this.responsavelLogin = "";
                await this.persistResponsavelPrazo({ dsLogin: null, force: true });
                this.$emit('atualizar');
            },

            async persistResponsavelPrazo(opts = {}) {
                if (!this.flProprietario) {
                    this.saveState = 'error';
                    avisoErro('Somente o proprietário pode alterar.');
                    return;
                }

                const { dsLogin = this.responsavelLogin, force = false } = opts;

                // mantém sua regra: só salva se tiver data válida (exceto force)
                if (!force && !this.isPrazoBloqueado && (!this.dataLimiteDate || this.dataLimiteInvalida)) return;

                try {
                    this.saveState = 'saving';

                    let dtLimiteFmt = null;

                    if (this.dataLimiteDate) {
                        // Normaliza sentinelas (caso ainda chegue algo errado no model)
                        if (this.dataLimiteDate === '0001-01-01' || this.dataLimiteDate === '1901-01-01') {
                            dtLimiteFmt = null;
                        } else {
                            // parse strict para evitar lixo
                            const m = moment(this.dataLimiteDate, 'YYYY-MM-DD', true);

                            if (m.isValid()) {
                                // 23:59 no horário local (mesma intenção do seu new Date)
                                dtLimiteFmt = m
                                    .hour(23).minute(59).second(0).millisecond(0)
                                    .format('YYYY-MM-DDTHH:mm:ss');
                            } else {
                                dtLimiteFmt = null;
                            }
                        }
                    }

                    const payload = {
                        DadosProcessoArtefatoResponsavel: {
                            idProcessoArtefatoResponsavel: this.idProcessoArtefatoResponsavel || 0,
                            idProcesso: parseInt(this.idProcesso),
                            idProcessoModeloArtefato: parseInt(this.idProcessoModeloArtefato),
                            dsLogin: dsLogin ?? null,
                            dtLimite: dtLimiteFmt, // <- null quando não tem data
                        },
                        nrOrdem: this.nrOrdem ?? null
                    };

                    await axios.post(`${urlApi}/ProcessoArtefatoResponsavel/PostProcessoArtefatoResponsavel`, payload);
                    await this.getResponsavel();

                    this.saveState = 'saved';
                    setTimeout(() => (this.saveState = 'idle'), 1200);
                } catch (e) {
                    this.saveState = 'error';
                    avisoErro('Falha ao salvar alterações de responsável/prazo.');
                }
            },

            ensureResponsavelInList() {
                if (this.responsavelLogin && !this.lstUsuariosResponsavel.some(u => u.dsLogin === this.responsavelLogin)) {
                    this.lstUsuariosResponsavel.push({
                        dsLogin: this.responsavelLogin,
                        nmUsuario: this.responsavelLogin,
                    });
                }
            },

            showEnvioArquivoProcessamento() {
                if (this.estaBloqueado) { avisoErro(this.motivoBloqueio); return; }
                if (this.myModalAlternative) {
                    this.myModalAlternative.hide();
                }

                this.lstArquivosProcessamento = [];
                this.resetUpload = !this.resetUpload;

                setTimeout(() => {
                    this.ModalEnvioArquivoProcessamento = new window.bootstrap.Modal('#ModalEnvioArquivoProcessamento');
                    this.ModalEnvioArquivoProcessamento.show();
                }, 100);
            },

            enviarArquivoProcessamento() {
                let $this = this;

                const lstArquivos = (this.lstArquivosProcessamento || [])
                    .filter(a => a && a.key)
                    .map(a => ({ key: a.key, fileName: a.fileName }));

                if (lstArquivos.length === 0) {
                    avisoErro("Nenhum arquivo selecionado.");
                    return false;
                }

                if (lstArquivos.length > this.maxArquivosGA) {
                    avisoErro(`São permitidos no máximo ${this.maxArquivosGA} arquivo(s) para este artefato.`);
                    return false;
                }

                axios.post(`${urlApi}/ProcessoArtefato/GerarIAArquivo`, {
                    idProcesso: $this.idProcesso,
                    idProcessoModeloArtefato: $this.idProcessoModeloArtefato,
                    idModeloArtefato: $this.processoModeloArtefatoConfiguracao.idModeloArtefato,
                    key: lstArquivos[0].key,
                    fileName: lstArquivos[0].fileName,
                    lstArquivos: lstArquivos
                })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstArquivosProcessamento = [];
                            $this.resetUpload = !$this.resetUpload;
                            avisoToast(`Processamento do ${this.processoModeloArtefato?.nmModelo} registrado com sucesso. Você será notificado quando estiver concluído.`);
                            $this.load();
                            $this.$emit('atualizar')
                            $this.ModalEnvioArquivoProcessamento.hide();
                        } else {
                            avisoErro("Não foi possível enviar o arquivo para processamento.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data) {
                            $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                            avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);
                        } else {
                            avisoErro("Não foi possível enviar o arquivo para processamento.");
                        }
                    });

                return false;
            },
        },

        mounted: function () {
            this.myModalAlternative = new window.bootstrap.Modal('#ModalProcessoArtefato');

            const modalUploadEl = document.getElementById('ModalUpload');
            if (modalUploadEl) {
                modalUploadEl.addEventListener('hidden.bs.modal', () => {
                    this.myModalAlternative.show();
                });
            }

            const modalResponsaveldEl = document.getElementById('ModalResponsavel');
            if (modalResponsaveldEl) {
                modalResponsaveldEl.addEventListener('hidden.bs.modal', () => {
                    this.myModalAlternative.show();
                });
            }

            const modalFormularioEl = document.getElementById('ModalFormulario');
            if (modalFormularioEl) {
                modalFormularioEl.addEventListener('hidden.bs.modal', () => {
                    this.myModalAlternative.show();
                });
            }

            const modalRetificarDocumentoEl = document.getElementById('ModalRetificarDocumento');
            if (modalRetificarDocumentoEl) {
                modalRetificarDocumentoEl.addEventListener('hidden.bs.modal', () => {
                    this.myModalAlternative.show();
                });
            }

            // signalR
            if (this.hubConection != undefined) {
                // signalR
                this.InitSignalR();
            }
        },
        beforeDestroy() {
            this.pararMonitoramentoStatusProcessamento();
        },
        watch: {
            showModal: function (val) {
                if (!val) {
                    this.pararMonitoramentoStatusProcessamento();
                    return;
                }
                this.myModalAlternative.show();

                this.resetUpload = !this.resetUpload;
                this.lstArquivosProcessamento = [];
                this.indexFormulario = 0;
                this.indexUltimaEtapaAvancada = 0;
                this.load();
            },
            
            processoModeloArtefato: {
                handler(novo) {
                    if ((novo?.nmModelo === 'Edital' || novo?.nmModelo === 'Minuta do Edital' ) && this.idLegislacao) {
                        this.getModeloEdital();
                    }
                    if (novo?.cdModelo == 10 && this.idLegislacao) {
                        this.getModeloTermoContrato();
                    }
                    if (novo?.cdModelo == 4 && this.idLegislacao) {
                        this.getModeloTermoReferencia();
                    }
                    if (novo?.cdModelo == 9 && this.idLegislacao) {
                        this.getModeloParecerParametrizado();
                    }
                    
                },
                immediate: true
            }
        }
    };
</script>

<style lang="scss">
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes slideInRight {
        from {
            opacity: 0;
            transform: translateX(-20px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    @keyframes pulse {
        0%, 100% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.02);
        }
    }

    /* Modal Enhancements */
    #ModalProcessoArtefato {
        .modal-content {
            border-radius: 24px;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
            background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
            animation: fadeInUp 0.4s ease-out;
        }

        .modal-body {
            padding: 0;
        }

        .list-group {
            max-height: calc((100vh - 150px) - 360px);
            overflow-y: auto;
        }

        .py-4.px-4 {
            padding: 1.5rem 2rem !important;

            @media (max-width: 768px) {
                padding: 1rem 1.25rem !important;
            }
        }

        .title {
            font-size: 2rem;
            font-weight: 700;
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            letter-spacing: -0.5px;
            position: relative;
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;

            i {
                background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                animation: pulse 2s ease-in-out infinite;
            }

            @media (max-width: 768px) {
                font-size: 1.5rem;
            }
        }

        hr {
            border: 0;
            height: 2px;
            background: linear-gradient(90deg, transparent, #1f7bff, transparent);
            opacity: 0.3;
            margin: 0.75rem 0;
        }

        h3 {
            font-size: 1.2rem;
            font-weight: 700;
            color: #2d3748;
            margin-bottom: 0.75rem;
            position: relative;
            padding-left: 1rem;

            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 4px;
                height: 70%;
                background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
                border-radius: 2px;
            }
        }
    }


    /* Alert Styling */
    .alert-warning {
        background: linear-gradient(135deg, #fff3cd 0%, #fff8e1 100%);
        border: 1px solid #ffe082;
        border-radius: 12px;
        padding: 0.875rem 1rem;
        box-shadow: 0 4px 12px rgba(255, 193, 7, 0.15);
        animation: slideInRight 0.5s ease-out;
        margin-bottom: 1rem !important;

        i {
            color: #ff9800;
            font-size: 1.1rem;
        }

        strong {
            color: #f57c00;
        }
    }

    /* Action Buttons */
    .btn {
        border-radius: 10px;
        font-weight: 600;
        padding: 0.65rem 1.25rem;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border: none;
        position: relative;
        overflow: hidden;
        font-size: 0.9rem;

        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 220%;
            height: 220%;
            border-radius: 50%;
            background: rgba(255,255,255,0.30);
            transform: translate(-50%, -50%) scale(0);
            transition: transform .6s ease;
            pointer-events: none;
        }

        &:hover::before {
            transform: translate(-50%, -50%) scale(1);
        }

        &:hover:not(:disabled) {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(31, 123, 255, 0.3);
        }

        &:active:not(:disabled) {
            transform: translateY(0);
        }

        &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }
    }

    .btn-light {
        background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
        border: 2px solid #e9ecef;
        color: #495057;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

        &:hover:not(:disabled) {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            color: white;
            border-color: transparent;
            box-shadow: 0 8px 24px rgba(31, 123, 255, 0.3);
        }
    }

    .btn-outline-light {
        background: transparent;
        border: 2px dashed #dee2e6;
        color: #6c757d;

        &:hover:not(:disabled) {
            background: rgba(31, 123, 255, 0.05);
            border-color: #1f7bff;
            color: #1f7bff;
        }
    }

    .btn-primary {
        background: linear-gradient(135deg, #1f7bff 0%, #0056d2 100%);
        box-shadow: 0 4px 12px rgba(31, 123, 255, 0.3);

        &:hover {
            background: linear-gradient(135deg, #0056d2 0%, #003d99 100%);
            box-shadow: 0 8px 24px rgba(31, 123, 255, 0.4);
        }
    }

    .btn-warning {
        background: linear-gradient(135deg, #ffc107 0%, #ff9800 100%);
        color: white;
        box-shadow: 0 4px 12px rgba(255, 193, 7, 0.3);

        &:hover {
            background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
            box-shadow: 0 8px 24px rgba(255, 193, 7, 0.4);
        }
    }

    .btn-outline-danger {
        border: 2px solid #dc3545;
        color: #dc3545;
        background: transparent;

        &:hover {
            background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
            color: white;
            box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
        }
    }

    /* Forms */
    .border-danger {
        border-color: #E8B6C1 !important;
        box-shadow: 0 0 0 0.2rem rgba(196, 104, 110, 0.25);
        animation: pulse 1s ease-in-out 1;
    }

    .form-control,
    .form-select {
        border: 2px solid #e9ecef;
        border-radius: 10px;
        padding: 0.65rem 1rem;
        transition: all 0.3s ease;
        background-color: #ffffff;
        font-size: 0.95rem;

        &:focus {
            border-color: #1f7bff;
            box-shadow: 0 0 0 0.25rem rgba(31, 123, 255, 0.15);
            background-color: #ffffff;
        }

        &:hover:not(:focus) {
            border-color: #cbd5e0;
        }
    }

    input[type="file"] {
        display: none;
    }

    .custom-file-upload {
        display: inline-block;
        padding: 0.75rem 2rem;
        cursor: pointer;
        background: linear-gradient(135deg, #0051ad 0%, #00bf51 100%);
        font-weight: 600;
        font-size: 1rem;
        line-height: 1.5;
        color: #FFF;
        border-radius: 12px;
        transition: all 0.3s ease;
        box-shadow: 0 4px 12px rgba(0, 81, 173, 0.3);

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 24px rgba(0, 81, 173, 0.4);
        }
    }

    .upload-center {
        display: flex;
        justify-content: center;
        margin-left: 0;
        padding: 1rem 0;
    }

    .upload-center ::v-deep .row {
        justify-content: center !important;
    }

    .upload-center ::v-deep .col-6,
    .upload-center ::v-deep .col {
        flex: 0 0 auto !important;
        max-width: 400px;
        width: 100%;
    }

    .upload-center ::v-deep .input-group {
        width: 100%;
    }

    /* List Groups */
    .list-group {
        max-height: 40vh;
        overflow-y: auto;
        border-radius: 12px;
        padding: 0.25rem;
        
        /* Custom Scrollbar */
        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 10px;
        }

        &::-webkit-scrollbar-thumb {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            border-radius: 10px;

            &:hover {
                background: linear-gradient(135deg, #0056d2 0%, #00a065 100%);
            }
        }
    }

    .list-group-historico {
        padding: 0.75rem;
        margin-bottom: 0.375rem;
        border-radius: 10px;
        transition: all 0.3s ease;
        border: 1px solid transparent;
        background: #ffffff;

        &:hover {
            transform: translateX(4px);
            box-shadow: 0 4px 12px rgba(31, 123, 255, 0.15);
            border-color: #1f7bff;
        }

        &:nth-child(odd) {
            background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
        }

        &:nth-child(even) {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        }

        .tyn-media-group {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 1rem;
            font-size: 0.9rem;
            color: #495057;
            font-weight: 500;
        }

        .btn-icon {
            width: 36px;
            height: 36px;
            border-radius: 10px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;

            &:hover {
                transform: scale(1.1) rotate(5deg);
            }
        }
    }

    /* Wizard Indicators */
    .wizard-indicators {
        display: flex;
        justify-content: space-between;
        position: relative;
        padding: 1rem 0;
        overflow-x: auto;
        gap: 0;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 12px;
        margin-bottom: 1rem;

        /* Custom Scrollbar for Wizard */
        &::-webkit-scrollbar {
            height: 6px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 10px;
        }

        &::-webkit-scrollbar-thumb {
            background: linear-gradient(90deg, #1f7bff 0%, #00d084 100%);
            border-radius: 10px;
        }

        .wizard-step {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 1;
            min-width: 50px;
            cursor: pointer;

            .line {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translateX(10px);
                width: calc(100% - 20px);
                height: 3px;
                background: linear-gradient(90deg, #e9ecef 0%, #dee2e6 100%);
                z-index: 1;
                border-radius: 2px;
                transition: all 0.4s ease;
            }

            .circle {
                width: 32px;
                height: 32px;
                font-size: 0.85rem;
                line-height: 1;
                border-radius: 50%;
                background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);
                color: #6c757d;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 700;
                z-index: 2;
                transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                transform: scale(1);
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                border: 3px solid #ffffff;
            }

            &.completed .circle {
                background: linear-gradient(135deg, #11D546 0%, #0ea83d 100%);
                color: #fff;
                transform: scale(1.05);
                box-shadow: 0 4px 12px rgba(17, 213, 70, 0.4);
                animation: completePulse 0.6s ease-out;
            }

            &.completed .line {
                background: linear-gradient(90deg, #11D546 0%, #0ea83d 100%);
                height: 3px;
            }

            &.obrigatoria .circle {
                background: linear-gradient(135deg, #00d084, #1f7bff);
                background-size: 300% 300%;
                animation: borderGradientPulse 3s ease infinite;
                box-shadow: 0 0 16px rgba(0, 208, 132, 0.5), 0 0 16px rgba(31, 123, 255, 0.5);
                color: #fff;
            }

            &.active .circle {
                transform: scale(1.5) !important;
                color: #fff !important;
                box-shadow: 0 6px 20px rgba(31, 123, 255, 0.5);
            }

            &:hover .circle {
                transform: scale(1.15);
            }
        }

        .wizard-step:not(:last-child) {
            margin-right: 0;
        }

        .label {
            display: none !important;
        }

        @keyframes borderGradientPulse {
            0% {
                background-position: 0% 50%;
            }
            50% {
                background-position: 100% 50%;
            }
            100% {
                background-position: 0% 50%;
            }
        }

        @keyframes completePulse {
            0% {
                transform: scale(1);
            }
            50% {
                transform: scale(1.2);
            }
            100% {
                transform: scale(1.05);
            }
        }
    }

    /* Modal Sizes */
    .modal-xxl {
        width: calc(100vw - 50px);
        max-width: calc(100vw - 50px);
        height: calc(100vh - 50px);
        margin: 25px;
        
        .modal-content {
            height: 100%;
            max-height: calc(100vh - 50px);
        }

        .modal-body {
            overflow-y: auto;
            max-height: calc(100vh - 50px);
            padding: 0;
            
            /* Custom Scrollbar */
            &::-webkit-scrollbar {
                width: 10px;
            }

            &::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 10px;
                margin: 10px 0;
            }

            &::-webkit-scrollbar-thumb {
                background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
                border-radius: 10px;

                &:hover {
                    background: linear-gradient(135deg, #0056d2 0%, #00a065 100%);
                }
            }
        }
        
        @media (max-width: 768px) {
            width: calc(100vw - 20px);
            max-width: calc(100vw - 20px);
            height: calc(100vh - 20px);
            margin: 10px;

            .modal-content {
                max-height: calc(100vh - 20px);
            }

            .modal-body {
                max-height: calc(100vh - 20px);

                &::-webkit-scrollbar {
                    width: 6px;
                }
            }
        }
    }

    .modal-xl {
        width: calc(100vw - 40px);
        max-width: calc(100vw - 40px);
        margin: 20px;

        .modal-content {
            border-radius: 20px;
            box-shadow: 0 15px 50px rgba(0, 0, 0, 0.25);
        }

        @media (max-width: 768px) {
            width: calc(100vw - 20px);
            max-width: calc(100vw - 20px);
            margin: 10px;
        }
    }

    /* Card Responsável - Modern Design */
    .card-responsavel {
        background: linear-gradient(135deg, rgba(248, 249, 250, 0.95) 0%, rgba(233, 236, 239, 0.95) 100%);
        backdrop-filter: blur(10px);
        border: 2px solid rgba(31, 123, 255, 0.15);
        border-radius: 14px;
        padding: 1rem 1.25rem;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(31, 123, 255, 0.1);
        width: 100%;
        transition: all 0.3s ease;
        margin-bottom: 1.25rem;

        &:hover {
            box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(31, 123, 255, 0.2);
            border-color: rgba(31, 123, 255, 0.3);
        }
    }

    .card-responsavel-body {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: nowrap;
    }
    
    .card-responsavel-body .fa-user-circle {
        font-size: 1.5rem;
        flex-shrink: 0;
        color: #1f7bff;
        filter: drop-shadow(0 2px 4px rgba(31, 123, 255, 0.3));
    }

    .card-responsavel-body .form-select {
        border-radius: 10px;
        border: 2px solid #e9ecef;
        background-color: #fff;
        padding: 0.6rem 1rem;
        font-weight: 500;
        transition: all 0.3s ease;

        &:hover:not(:focus) {
            border-color: #cbd5e0;
        }
    }

    .card-responsavel-body .form-select:focus {
        border-color: #1f7bff;
        box-shadow: 0 0 0 0.25rem rgba(31, 123, 255, 0.15);
    }

    .card-responsavel-body .prazo-input {
        width: 190px;
        border-radius: 10px;
        border: 2px solid #e9ecef;
        background-color: #fff;
        flex-shrink: 0;
        padding: 0.6rem 1rem;
        font-weight: 500;
        transition: all 0.3s ease;

        &:hover:not(:disabled):not(:focus) {
            border-color: #cbd5e0;
        }
    }

    .card-responsavel-body .prazo-input:focus {
        border-color: #1f7bff;
        box-shadow: 0 0 0 0.25rem rgba(31, 123, 255, 0.15);
    }

    .card-responsavel-body .prazo-input.prazo-disabled {
        background-color: #f8f9fa;
        opacity: 0.8;
        cursor: not-allowed;
    }

    .card-responsavel-body .prazo-input:disabled {
        background-color: #f8f9fa;
        opacity: 0.8;
    }

    .card-responsavel-body .fa-calendar-alt {
        flex-shrink: 0;
        color: #6c757d;
    }

    .card-responsavel-body .fa-lock {
        flex-shrink: 0;
        color: #dc3545;
        filter: drop-shadow(0 1px 2px rgba(220, 53, 69, 0.3));
    }

    .card-responsavel-actions {
        display: flex;
        gap: 10px;
        align-items: center;
        flex-shrink: 0;
    }

    .card-responsavel-actions .btn {
        padding: 0.65rem 1.25rem;
        border-radius: 10px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        flex-shrink: 0;
        font-size: 0.95rem;
        font-weight: 600;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 44px;
        height: 44px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        i {
            font-size: 1rem;
        }
    }

    .card-responsavel-actions .btn-sm {
        padding: 0.65rem 1.25rem;
        height: 44px;
        border: 2px solid transparent;
    }

    .card-responsavel-actions .btn-primary {
        background: linear-gradient(135deg, #1f7bff 0%, #0056d2 100%);
        border: none;

        &:hover {
            background: linear-gradient(135deg, #0056d2 0%, #003d99 100%);
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(31, 123, 255, 0.4);
        }

        &:active {
            transform: translateY(0);
        }
    }

    .card-responsavel-actions .btn-outline-danger {
        border: 2px solid #dc3545;
        background: transparent;
        color: #dc3545;

        &:hover {
            background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
            border-color: #dc3545;
            color: white;
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(220, 53, 69, 0.4);
        }

        &:active {
            transform: translateY(0);
        }
    }

    .card-responsavel-actions small {
        white-space: nowrap;
        flex-shrink: 0;
        font-weight: 600;
        font-size: 0.875rem;
        padding: 0 0.25rem;
    }

    .card-responsavel-body-readonly {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 0.75rem 1rem;
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 249, 250, 0.9) 100%);
        border-radius: 10px;
        border: 2px solid #e9ecef;
        flex-wrap: nowrap;
        transition: all 0.3s ease;

        &:hover {
            border-color: #cbd5e0;
        }
    }

    .card-responsavel-body-readonly .fa-user-circle {
        font-size: 1.5rem;
        flex-shrink: 0;
        color: #1f7bff;
    }

    .responsavel-nome {
        font-weight: 600;
        color: #2d3748;
        white-space: nowrap;
    }

    /* Close Button */
    .btn-pill {
        border-radius: 50% !important;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        background-color: #ffffff !important;
        border: 2px solid #e9ecef !important;
        width: 48px !important;
        height: 48px !important;
        min-width: 48px !important;
        max-width: 48px !important;
        min-height: 48px !important;
        max-height: 48px !important;
        display: flex !important;
        align-items: center;
        justify-content: center;
        padding: 0 !important;
        flex-shrink: 0 !important;
        flex-grow: 0 !important;
        
        svg {
            transition: all 0.3s ease;
            color: #6c757d;
        }
        
        &:hover {
            transform: scale(1.1);
            background: linear-gradient(135deg, #dc3545 0%, #c82333 100%) !important;
            border-color: #dc3545 !important;
            box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
            
            svg {
                color: #ffffff;
                /*transform: rotate(90deg);*/
            }
        }
        
        &:active {
            transform: scale(0.95);
        }
    }

    /* Responsive Design */
    @media (max-width: 1200px) {
        h3 {
            font-size: 1.1rem;
        }

        .btn {
            padding: 0.6rem 1.2rem;
            font-size: 0.9rem;
        }

        .btn-pill {
            width: 48px !important;
            height: 48px !important;
            padding: 0 !important;
            min-width: 48px !important;
            max-width: 48px !important;
        }
    }

    @media (max-width: 992px) {
        .card-responsavel-body {
            flex-wrap: wrap;
            gap: 10px;
        }

        .card-responsavel-body .form-select {
            min-width: 200px;
            flex: 1;
        }

        .card-responsavel-body .prazo-input {
            width: 150px;
        }

        .list-group {
            max-height: 30vh;
        }
    }

    @media (max-width: 768px) {
        #ModalProcessoArtefato {
            .title {
                font-size: 1.5rem;
            }

            .modal-content {
                border-radius: 16px;
            }

            .py-4.px-4 {
                padding: 0.875rem 1rem !important;
            }
        }

        .btn {
            padding: 0.55rem 0.875rem;
            font-size: 0.85rem;
        }

        .btn-pill {
            width: 48px !important;
            height: 48px !important;
            padding: 0 !important;
            min-width: 48px !important;
            max-width: 48px !important;
        }

        h3 {
            font-size: 1rem;
            margin-bottom: 0.5rem;
        }

        .card-responsavel {
            padding: 0.875rem 1rem;
        }

        .wizard-indicators {
            .wizard-step .circle {
                width: 28px;
                height: 28px;
                font-size: 0.75rem;
            }
        }

        .list-group {
            max-height: 35vh;
        }
    }

    @media (max-width: 576px) {
        #ModalProcessoArtefato {
            .py-4.px-4 {
                padding: 1rem !important;
            }

            .title {
                font-size: 1.25rem;
            }
        }

        .card-responsavel-body {
            flex-direction: column;
            align-items: stretch;
            gap: 12px;
        }

        .card-responsavel-body .form-select,
        .card-responsavel-body .prazo-input {
            width: 100%;
        }

        .card-responsavel-actions {
            width: 100%;
            justify-content: flex-end;
        }

        .btn-pill {
            width: 48px !important;
            height: 48px !important;
            padding: 0 !important;
            min-width: 48px !important;
            max-width: 48px !important;
        }

        .card-responsavel-body-readonly {
            flex-wrap: wrap;
            justify-content: center;
            text-align: center;
        }

        .btn {
            width: 100%;
            margin-top: 0.5rem;
        }

        .list-group {
            max-height: 25vh;
        }

        .list-group-historico {
            padding: 0.75rem;

            .tyn-media-group {
                flex-direction: column;
                align-items: flex-start;
                gap: 0.5rem;
                font-size: 0.85rem;
            }
        }

        .wizard-indicators {
            .wizard-step .circle {
                width: 24px;
                height: 24px;
                font-size: 0.7rem;
                border-width: 2px;
            }

            .wizard-step.active .circle {
                transform: scale(1.3) !important;
            }
        }

        .upload-center {
            margin-left: 0;
            padding: 1rem 0;
        }
    }

    /* Popover Custom Styling */
    .custom-popover {
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        border: 2px solid rgba(31, 123, 255, 0.2);

        .popover-header {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            color: white;
            border-radius: 10px 10px 0 0;
            font-weight: 600;
        }

        .popover-body {
            font-size: 0.9rem;
            line-height: 1.6;
        }
    }

    /* Additional Modal Styles */
    #ModalUpload,
    #ModalFormulario,
    #ModalRetificarDocumento
    {
        .modal-content {
            border-radius: 20px;
            box-shadow: 0 15px 50px rgba(0, 0, 0, 0.25);
            background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
            animation: fadeInUp 0.4s ease-out;
        }

        .title {
            font-size: 1.75rem;
            font-weight: 700;
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }

        hr {
            border: 0;
            height: 2px;
            background: linear-gradient(90deg, transparent, #1f7bff, transparent);
            opacity: 0.3;
            margin: 0.75rem 0;
        }

        .py-4.px-4 {
            padding: 1.5rem 2rem !important;

            @media (max-width: 768px) {
                padding: 1rem 1.25rem !important;
            }
        }
    }

    /* Section Cards - Subtle Visual Difference */
    .section-card {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.6) 0%, rgba(248, 249, 250, 0.4) 100%);
        border: 1px solid rgba(31, 123, 255, 0.08);
        border-radius: 12px;
        padding: 1rem;
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);

        &:hover {
            background: linear-gradient(135deg, rgba(255, 255, 255, 0.8) 0%, rgba(248, 249, 250, 0.6) 100%);
            border-color: rgba(31, 123, 255, 0.12);
            box-shadow: 0 4px 12px rgba(31, 123, 255, 0.08);
        }

        h3 {
            margin-bottom: 0 !important;
        }

        .list-group {
            background: transparent;
        }
    }

    /* Layout Optimizations */
    .row.g-3 {
        row-gap: 1rem;
        column-gap: 1rem;
    }

    .d-flex.gap-2 {
        gap: 0.5rem !important;
    }

    .d-flex.gap-3 {
        gap: 1rem !important;
    }

    .mb-2 {
        margin-bottom: 0.5rem !important;
    }

    .mb-3 {
        margin-bottom: 1rem !important;
    }

    .mt-3 {
        margin-top: 1rem !important;
    }

    /* Loading States */
    .text-muted {
        opacity: 0.7;
    }

    .text-success {
        color: #11D546 !important;
        font-weight: 600;
    }

    .text-danger {
        color: #dc3545 !important;
        font-weight: 600;
    }

    .text-primary {
        color: #1f7bff !important;
        font-weight: 600;
    }

    /* Card de Ações Principais - Design Moderno */
    .card-acoes-principais {
        background: linear-gradient(135deg, rgba(248, 249, 250, 0.95) 0%, rgba(233, 236, 239, 0.95) 100%);
        backdrop-filter: blur(10px);
        border: 2px solid rgba(31, 123, 255, 0.15);
        border-radius: 14px;
        padding: 1rem 1.25rem;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(31, 123, 255, 0.1);
        width: 100%;
        transition: all 0.3s ease;
        margin-bottom: 1.5rem;

        &:hover {
            box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(31, 123, 255, 0.2);
            border-color: rgba(31, 123, 255, 0.3);
        }
    }

    .card-acoes-body {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        flex-wrap: wrap;
    }

    .btn-acoes {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0.75rem 1.5rem;
        border-radius: 12px;
        font-weight: 600;
        font-size: 0.95rem;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border: none;
        position: relative;
        overflow: hidden;
        flex: 1;
        min-width: 180px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

        span {
            position: relative;
            z-index: 2;
            white-space: nowrap;
        }

        i {
            position: relative;
            z-index: 2;
            font-size: 1.1rem;
        }

        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 0;
            height: 0;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.3);
            transform: translate(-50%, -50%);
            transition: width 0.6s, height 0.6s;
            z-index: 1;
        }

        &:hover::before {
            width: 300px;
            height: 300px;
        }

        &:hover:not(:disabled) {
            transform: translateY(-3px);
        }

        &:active:not(:disabled) {
            transform: translateY(-1px);
        }

        &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
            transform: none !important;
        }
    }

    .btn-download {
        background: linear-gradient(135deg, #00d084 0%, #00a065 100%);
        color: white;

        &:hover:not(:disabled) {
            background: linear-gradient(135deg, #00bf7a 0%, #00d084 100%);
            box-shadow: 0 8px 24px rgba(0, 208, 132, 0.4);
            color: white !important;
        }
    }

    .btn-fluxo {
        background: linear-gradient(135deg, #1f7bff 0%, #0056d2 100%);
        color: white;

        &:hover:not(:disabled) {
            background: linear-gradient(135deg, #4a94ff 0%, #1f7bff 100%);
            box-shadow: 0 8px 24px rgba(31, 123, 255, 0.4);
            color: white !important;
        }
    }

    .btn-revisado {
        background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
        color: white;

        &:hover:not(:disabled) {
            background: linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%);
            box-shadow: 0 8px 24px rgba(139, 92, 246, 0.4);
            color: white !important;
        }
    }

    .btn-ajustes {
        background: linear-gradient(135deg, #ffc107 0%, #ff9800 100%);
        color: white;

        &:hover:not(:disabled) {
            background: linear-gradient(135deg, #ffd54f 0%, #ffc107 100%);
            box-shadow: 0 8px 24px rgba(255, 193, 7, 0.4);
            color: white !important;
        }
    }

    .btn-retificacao {
        background: linear-gradient(135deg, #1f7bff 0%, #0056d2 100%);
        color: white;

        &:hover:not(:disabled) {
            background: linear-gradient(135deg, #4a94ff 0%, #1f7bff 100%);
            box-shadow: 0 8px 24px rgba(31, 123, 255, 0.4);
            color: white !important;
        }
    }

    /* Quando há apenas 1 botão */
    .card-acoes-body > .btn-acoes:only-child {
        max-width: 400px;
    }

    /* Quando há 2 botões */
    .card-acoes-body > .btn-acoes:nth-child(1):nth-last-child(2),
    .card-acoes-body > .btn-acoes:nth-child(2):nth-last-child(1) {
        flex: 1;
        max-width: 300px;
    }

    /* Responsivo para Card de Ações */
    @media (max-width: 992px) {
        .card-acoes-principais {
            padding: 0.875rem 1rem;
        }

        .card-acoes-body {
            gap: 0.75rem;
        }

        .btn-acoes {
            min-width: 150px;
            padding: 0.65rem 1.25rem;
            font-size: 0.9rem;
        }
    }

    @media (max-width: 768px) {
        .card-acoes-principais {
            padding: 0.75rem 0.875rem;
            margin-bottom: 1.25rem;
        }

        .card-acoes-body {
            gap: 0.625rem;
        }

        .btn-acoes {
            min-width: 140px;
            padding: 0.6rem 1rem;
            font-size: 0.875rem;

            i {
                font-size: 1rem;
            }
        }

        .btn-acoes span {
            font-size: 0.85rem;
        }
    }

    @media (max-width: 576px) {
        .card-acoes-principais {
            padding: 0.75rem;
            margin-bottom: 1rem;
        }

        .card-acoes-body {
            flex-direction: column;
            gap: 0.625rem;
        }

        .btn-acoes {
            width: 100%;
            min-width: unset;
            max-width: 100%;
            flex: none;
        }

        .btn-acoes:only-child {
            max-width: 100%;
        }

        .card-acoes-body > .btn-acoes:nth-child(1):nth-last-child(2),
        .card-acoes-body > .btn-acoes:nth-child(2):nth-last-child(1) {
            max-width: 100%;
        }
    }

    /* ============================================
       DARK THEME - Modern & Beautiful
       ============================================ */

    /* Modal Base */
    [data-bs-theme="dark"] #ModalProcessoArtefato .modal-content,
    [data-bs-theme="dark"] #ModalUpload .modal-content,
    [data-bs-theme="dark"] #ModalFormulario .modal-content,
    [data-bs-theme="dark"] #ModalRetificarDocumento .modal-content
    {
        background: linear-gradient(135deg, #1a1d29 0%, #1e2330 100%);
        border: 1px solid rgba(255, 255, 255, 0.1);
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
    }

    /* Títulos */
    [data-bs-theme="dark"] #ModalProcessoArtefato .title,
    [data-bs-theme="dark"] #ModalUpload .title,
    [data-bs-theme="dark"] #ModalFormulario .title,
    [data-bs-theme="dark"] #ModalRetificarDocumento .title    
    {
        background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;

        i {
            background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }
    }

    [data-bs-theme="dark"] h3 {
        color: #ffffff !important;
        font-weight: 700 !important;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

        &::before {
            background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
        }

        i {
            color: #ffffff !important;
        }
    }

    /* HR Dividers */
    [data-bs-theme="dark"] hr {
        background: linear-gradient(90deg, transparent, rgba(96, 165, 250, 0.5), transparent);
    }

    /* Alerts */
    [data-bs-theme="dark"] .alert-warning {
        background: linear-gradient(135deg, #78350f 0%, #92400e 100%);
        border-color: rgba(245, 158, 11, 0.3);
        color: #fcd34d;
        box-shadow: 0 4px 12px rgba(245, 158, 11, 0.2);

        i {
            color: #fbbf24;
        }

        strong {
            color: #fcd34d;
        }
    }

    [data-bs-theme="dark"] .alert-success {
        background: linear-gradient(135deg, #064e3b 0%, #065f46 100%);
        border-color: rgba(16, 185, 129, 0.3);
        color: #6ee7b7;
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);

        i {
            color: #34d399;
        }

        strong {
            color: #6ee7b7;
        }
    }

    /* Buttons Light */
    [data-bs-theme="dark"] .btn-light {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border-color: rgba(255, 255, 255, 0.12);
        color: #d1d5db;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

        &:hover:not(:disabled) {
            background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
            color: white;
            border-color: transparent;
            box-shadow: 0 8px 24px rgba(96, 165, 250, 0.4);
        }
    }

    [data-bs-theme="dark"] .btn-outline-light {
        background: transparent;
        border-color: rgba(255, 255, 255, 0.12);
        color: #9ca3af;

        &:hover:not(:disabled) {
            background: rgba(96, 165, 250, 0.1);
            border-color: #60a5fa;
            color: #60a5fa;
        }
    }

    /* Buttons Primary */
    [data-bs-theme="dark"] .btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);

        &:hover:not(:disabled) {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            box-shadow: 0 8px 24px rgba(59, 130, 246, 0.5);
        }
    }

    /* Buttons Warning */
    [data-bs-theme="dark"] .btn-warning {
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        color: white;
        box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);

        &:hover:not(:disabled) {
            background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
            box-shadow: 0 8px 24px rgba(251, 191, 36, 0.5);
        }
    }

    /* Buttons Outline Danger */
    [data-bs-theme="dark"] .btn-outline-danger {
        border-color: #ef4444;
        color: #fca5a5;
        background: transparent;

        &:hover:not(:disabled) {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            color: white;
            box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
        }
    }

    /* Forms */
    [data-bs-theme="dark"] .form-control,
    [data-bs-theme="dark"] .form-select {
        background: #0f1117;
        border-color: rgba(255, 255, 255, 0.12);
        color: #e5e7eb;

        &:focus {
            background: #1a1d29;
            border-color: rgba(96, 165, 250, 0.5);
            box-shadow: 0 0 0 0.25rem rgba(96, 165, 250, 0.15);
            color: #f3f4f6;
        }

        &:hover:not(:focus) {
            border-color: rgba(255, 255, 255, 0.2);
        }

        &::placeholder {
            color: #6b7280;
        }
    }

    [data-bs-theme="dark"] .form-control:disabled,
    [data-bs-theme="dark"] .form-select:disabled {
        background: #1a1d29;
        opacity: 0.6;
        color: #6b7280;
    }

    /* Border Danger */
    [data-bs-theme="dark"] .border-danger {
        border-color: #ef4444 !important;
        box-shadow: 0 0 0 0.2rem rgba(239, 68, 68, 0.25);
    }

    [data-bs-theme="dark"] .is-invalid {
        border-color: #ef4444 !important;
    }

    /* List Groups */
    [data-bs-theme="dark"] .list-group {
        &::-webkit-scrollbar-track {
            background: #0f1117;
        }

        &::-webkit-scrollbar-thumb {
            background: linear-gradient(135deg, #4b5563 0%, #6b7280 100%);

            &:hover {
                background: linear-gradient(135deg, #6b7280 0%, #9ca3af 100%);
            }
        }
    }

    [data-bs-theme="dark"] .list-group-historico {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border-color: rgba(255, 255, 255, 0.08);
        color: #f3f4f6;

        &:hover {
            box-shadow: 0 4px 12px rgba(96, 165, 250, 0.2);
            border-color: rgba(96, 165, 250, 0.3);
        }

        &:nth-child(odd) {
            background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        }

        &:nth-child(even) {
            background: linear-gradient(135deg, #1a1d29 0%, #1e2330 100%);
        }

        .tyn-media-group {
            color: #f3f4f6 !important;
            font-weight: 500;
        }
    }

    /* Card Responsável */
    [data-bs-theme="dark"] .card-responsavel {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border-color: rgba(96, 165, 250, 0.2);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4), 0 2px 8px rgba(96, 165, 250, 0.2);

        &:hover {
            box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5), 0 4px 12px rgba(96, 165, 250, 0.3);
            border-color: rgba(96, 165, 250, 0.3);
        }
    }

    [data-bs-theme="dark"] .card-responsavel-body .form-select {
        background: #0f1117;
        border-color: rgba(255, 255, 255, 0.12);
        color: #e5e7eb;

        &:hover:not(:focus) {
            border-color: rgba(255, 255, 255, 0.2);
        }
    }

    [data-bs-theme="dark"] .card-responsavel-body .prazo-input {
        background: #0f1117;
        border-color: rgba(255, 255, 255, 0.12);
        color: #e5e7eb;

        &:hover:not(:disabled):not(:focus) {
            border-color: rgba(255, 255, 255, 0.2);
        }

        &.prazo-disabled,
        &:disabled {
            background: #1a1d29;
            opacity: 0.6;
        }
    }

    [data-bs-theme="dark"] .card-responsavel-body .fa-lock {
        color: #ef4444;
        filter: drop-shadow(0 1px 2px rgba(239, 68, 68, 0.4));
    }

    [data-bs-theme="dark"] .card-responsavel-body-readonly {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border-color: rgba(255, 255, 255, 0.12);

        &:hover {
            border-color: rgba(255, 255, 255, 0.2);
        }

        .fa-user-circle {
            color: #60a5fa;
        }
    }

    [data-bs-theme="dark"] .responsavel-nome {
        color: #f3f4f6;
    }

    /* Card de Ações Principais */
    [data-bs-theme="dark"] .card-acoes-principais {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border-color: rgba(96, 165, 250, 0.2);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4), 0 2px 8px rgba(96, 165, 250, 0.2);

        &:hover {
            box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5), 0 4px 12px rgba(96, 165, 250, 0.3);
            border-color: rgba(96, 165, 250, 0.3);
        }
    }

    [data-bs-theme="dark"] .btn-download {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);

        &:hover:not(:disabled) {
            background: linear-gradient(135deg, #34d399 0%, #10b981 100%);
            box-shadow: 0 8px 24px rgba(16, 185, 129, 0.5);
        }
    }

    [data-bs-theme="dark"] .btn-fluxo {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);

        &:hover:not(:disabled) {
            background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
            box-shadow: 0 8px 24px rgba(59, 130, 246, 0.5);
        }
    }

    [data-bs-theme="dark"] .btn-revisado {
        background: linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%);

        &:hover:not(:disabled) {
            background: linear-gradient(135deg, #c4b5fd 0%, #a78bfa 100%);
            box-shadow: 0 8px 24px rgba(167, 139, 250, 0.5);
        }
    }

    [data-bs-theme="dark"] .btn-ajustes {
        background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);

        &:hover:not(:disabled) {
            background: linear-gradient(135deg, #fcd34d 0%, #fbbf24 100%);
            box-shadow: 0 8px 24px rgba(251, 191, 36, 0.5);
        }
    }

    [data-bs-theme="dark"] .btn-retificacao {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);

        &:hover:not(:disabled) {
            background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
            box-shadow: 0 8px 24px rgba(59, 130, 246, 0.5);
        }
    }

    /* Section Cards */
    [data-bs-theme="dark"] .section-card {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border-color: rgba(96, 165, 250, 0.15);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

        &:hover {
            background: linear-gradient(135deg, #252b3d 0%, #2d3548 100%);
            border-color: rgba(96, 165, 250, 0.25);
            box-shadow: 0 4px 12px rgba(96, 165, 250, 0.2);
        }

        h3 {
            color: #ffffff !important;
            
            i {
                color: #ffffff !important;
            }
        }
    }

    /* Wizard Indicators */
    [data-bs-theme="dark"] .wizard-indicators {
        background: rgba(30, 35, 48, 0.5);

        &::-webkit-scrollbar-track {
            background: #0f1117;
        }

        &::-webkit-scrollbar-thumb {
            background: linear-gradient(90deg, #3b82f6 0%, #10b981 100%);
        }

        .wizard-step {
            .line {
                background: linear-gradient(90deg, #374151 0%, #4b5563 100%);
            }

            .circle {
                background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
                color: #9ca3af;
                border-color: #1a1d29;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
            }

            &.completed .circle {
                background: linear-gradient(135deg, #10b981 0%, #059669 100%);
                box-shadow: 0 4px 12px rgba(16, 185, 129, 0.5);
            }

            &.completed .line {
                background: linear-gradient(90deg, #10b981 0%, #059669 100%);
            }

            &.obrigatoria .circle {
                background: linear-gradient(135deg, #34d399, #60a5fa);
                box-shadow: 0 0 16px rgba(52, 211, 153, 0.5), 0 0 16px rgba(96, 165, 250, 0.5);
            }

            &.active .circle {
                box-shadow: 0 6px 20px rgba(96, 165, 250, 0.6);
            }
        }
    }

    /* Close Button */
    [data-bs-theme="dark"] .btn-pill {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%) !important;
        border-color: rgba(255, 255, 255, 0.12) !important;

        svg {
            color: #d1d5db;
        }

        &:hover {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
            border-color: #ef4444 !important;
            box-shadow: 0 6px 20px rgba(239, 68, 68, 0.5);

            svg {
                color: #ffffff;
            }
        }
    }

    /* Text Colors */
    [data-bs-theme="dark"] .text-muted {
        color: #e5e7eb !important;
        opacity: 1;
    }

    [data-bs-theme="dark"] .text-success {
        color: #86efac !important;
        font-weight: 600;
    }

    [data-bs-theme="dark"] .text-danger {
        color: #fca5a5 !important;
        font-weight: 600;
    }

    [data-bs-theme="dark"] .text-primary {
        color: #93c5fd !important;
        font-weight: 600;
    }

    [data-bs-theme="dark"] .card-responsavel-body .fa-user-circle,
    [data-bs-theme="dark"] .card-responsavel-body .fa-calendar-alt {
        color: #60a5fa !important;
    }

    [data-bs-theme="dark"] i.text-muted {
        color: #d1d5db !important;
    }

    /* Ícones de título (history e tasks) */
    [data-bs-theme="dark"] .fas.fa-history,
    [data-bs-theme="dark"] .fas.fa-tasks,
    [data-bs-theme="dark"] .fas.fa-file-alt,
    [data-bs-theme="dark"] .fas.fa-clipboard-list,
    [data-bs-theme="dark"] .fas.fa-file-contract,
    [data-bs-theme="dark"] .fas.fa-cloud-upload-alt,
    [data-bs-theme="dark"] .far.fa-file-alt,
    [data-bs-theme="dark"] .far.fa-folder-open {
        color: #ffffff !important;
    }

    /* Ícones de informação */
    [data-bs-theme="dark"] .fas.fa-info-circle,
    [data-bs-theme="dark"] .fas.fa-circle-info,
    [data-bs-theme="dark"] .fas.fa-lightbulb,
    [data-bs-theme="dark"] .fas.fa-check-circle {
        opacity: 1;
    }

    /* Outros ícones */
    [data-bs-theme="dark"] i:not(.text-muted):not(.text-success):not(.text-danger):not(.text-primary) {
        color: #e5e7eb;
    }

    /* Upload Center */
    [data-bs-theme="dark"] .custom-file-upload {
        background: linear-gradient(135deg, #2563eb 0%, #10b981 100%);
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);

        &:hover {
            box-shadow: 0 8px 24px rgba(37, 99, 235, 0.5);
        }
    }

    /* Popover */
    [data-bs-theme="dark"] .custom-popover {
        background: #1e2330;
        border-color: rgba(96, 165, 250, 0.3);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);

        .popover-header {
            background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
            border-bottom-color: rgba(255, 255, 255, 0.1);
        }

        .popover-body {
            background: #1e2330;
            color: #d1d5db;
        }
    }

    /* Modal Body Scrollbar */
    [data-bs-theme="dark"] .modal-xxl .modal-body {
        &::-webkit-scrollbar-track {
            background: #0f1117;
        }

        &::-webkit-scrollbar-thumb {
            background: linear-gradient(135deg, #4b5563 0%, #6b7280 100%);

            &:hover {
                background: linear-gradient(135deg, #6b7280 0%, #9ca3af 100%);
            }
        }
    }

    /* Icon Buttons */
    [data-bs-theme="dark"] .btn-icon {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border-color: rgba(255, 255, 255, 0.12);
        color: #e5e7eb;

        i {
            color: #e5e7eb;
        }

        &:hover {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            color: white;
            border-color: #3b82f6;

            i {
                color: white;
            }
        }
    }

    [data-bs-theme="dark"] .btn-light .btn-icon {
        background: linear-gradient(135deg, #252b3d 0%, #2d3548 100%);
        border-color: rgba(255, 255, 255, 0.15);
        
        i {
            color: #f3f4f6;
        }

        &:hover {
            background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
            border-color: transparent;
            
            i {
                color: white;
            }
        }
    }

    /* fw-semibold */
    [data-bs-theme="dark"] .fw-semibold {
        color: #ffffff !important;
        font-weight: 600;
    }

    /* Generic paragraph text */
    [data-bs-theme="dark"] p {
        color: #f3f4f6 !important;
    }

    /* Small text */
    [data-bs-theme="dark"] small {
        color: #e5e7eb !important;
    }

    /* Strong emphasis */
    [data-bs-theme="dark"] strong {
        color: #ffffff !important;
        font-weight: 700;
    }

    /* Span generic */
    [data-bs-theme="dark"] span {
        color: #f3f4f6;
    }

    /* List items text */
    [data-bs-theme="dark"] li {
        color: #f3f4f6 !important;
        font-weight: 500;
    }
</style>

